var catalanTranslation = {
    translations: {
        philippinePassport: "Passaport filipí",
        seamanBook: "Llibreta de mariner",
        philSysID: "Identificació PhilSys",
        iBP: "Col·legi d'Advocats Integrat de Filipines (IBP)",
        driversLicense: "Permís de conduir",
        loading: "Carregant...",
        loadingDataProvider: "Carregant proveïdor de dades...",
        tallySheetImport: {
            title: "Importacions d'actes d'escrutini",
            subtitle: "Importa fitxers d'actes d'escrutini ES&S o CSV, previsualitza les urnes generades i aprova-les abans de crear actes d'escrutini.",
            createTitle: "Importar actes d'escrutini",
            detailTitle: "Importació d'acta d'escrutini",
            empty: "Encara no hi ha importacions d'actes d'escrutini.",
            emptyBody: "Comença important un fitxer ES&S Enhanced XML o CSV canònic per a aquest esdeveniment electoral.",
            sourceFormat: {
                ESS_ENHANCED_XML: "ES&S Enhanced XML",
                CANONICAL_CSV: "CSV canònic",
            },
            channel: {
                PAPER: "Paper",
                POSTAL: "Postal",
                IN_PERSON: "Presencial",
            },
            table: {
                created: "Creat",
                createdBy: "Creat per",
                file: "Fitxer",
                format: "Format",
                channel: "Canal",
                status: "Estat",
                labels: "Etiquetes",
                annotations: "Anotacions",
                actions: "Accions",
            },
            summary: {
                imported: "Importades",
                changed: "Modificades",
                new: "Noves",
                unchanged: "Sense canvis",
                conflicted: "En conflicte",
                errors: "Errors",
            },
            status: {
                PENDING_REVIEW: "Pendent de revisió",
                APPROVED: "Aprovada",
                DISAPPROVED: "Desaprovada",
                FAILED_VALIDATION: "Validació fallida",
                CONFLICTED: "En conflicte",
                NEW: "Nova",
                CHANGED: "Modificada",
                UNCHANGED: "Sense canvis",
            },
            fields: {
                format: "Format",
                channel: "Canal",
                supportedFormats: "Formats admesos: XML, CSV",
                generatedTallySheet: "Acta d'escrutini generada",
                sourceCandidates: "IDs de candidats d'origen",
                none: "Cap",
            },
            actions: {
                create: "Importar actes d'escrutini",
                review: "Revisar",
                source: "Origen",
                cancel: "Cancel·lar",
                preview: "Previsualitzar",
                save: "Desar importació",
                approve: "Aprovar",
                disapprove: "Desaprovar",
                close: "Tancar",
                openExisting: "Obrir existent",
            },
            notifications: {
                selectFile: "Selecciona un fitxer d'importació abans de previsualitzar-lo",
                duplicateSource: "Aquest hash de fitxer d'origen ja apareix en una importació d'acta d'escrutini anterior.",
                uploadUrlError: "No s'ha pogut crear la URL de pujada",
                uploadError: "No s'ha pogut pujar el fitxer d'importació",
                previewEmpty: "La resposta de la previsualització estava buida",
                previewError: "No s'ha pogut previsualitzar la importació",
                importEmpty: "La resposta de la importació estava buida",
                created: "S'ha creat la importació de l'acta d'escrutini",
                createError: "No s'ha pogut crear la importació",
                reviewEmpty: "La resposta de la revisió estava buida",
                conflicted: "La importació té conflictes de línia base desactualitzats",
                approved: "S'ha aprovat la importació",
                disapproved: "S'ha desaprovat la importació",
                reviewError: "No s'ha pogut revisar la importació",
                sourceUrlError: "No s'ha pogut crear la URL de descàrrega d'origen",
                sourceDownloadError: "No s'ha pogut descarregar el fitxer d'origen",
            },
            pagination: {
                range: "{{rangeStart}}-{{rangeEnd}} de {{total}}",
                previous: "Anterior",
                next: "Següent",
            },
        },
        reconciliation: {
            menuButton: "Sincr. votants ext.",
            categories: {
                VOTED_INTERNET: "Ha votat per Internet",
                VOTED_OTHER_CHANNEL: "Ha votat per un altre canal",
                DISABLED_DELETE_CALL: "Votant deshabilitat",
                DELETION_REVERTED: "Eliminació revertida",
                PROFILE_UPDATE: "Perfil actualitzat",
                VOTER_ADDED: "Votant afegit",
                REENABLED: "Votant rehabilitat",
                VOTED_UNMARKED: "Votant desmarcat com a votat",
                ROW_FAILURE: "Error de fila",
            },
            table: {
                voterId: "ID de Votant",
                field: "Camp",
                category: "Categoria",
                currentValue: "Valor actual",
                newValue: "Valor nou",
                reason: "Motiu",
                rowLabel: "Fila",
                noDifferences: "No s'han trobat diferències - els sistemes estan sincronitzats.",
            },
            wizard: {
                title: "Sincronització de reconciliació externa",
                subtitle: "Sincronitza la llista de votants amb el sistema extern",
                drop: {
                    description: "Deixa anar el fitxer de reconciliació generat pel sistema extern - ambdós diffs (costat extern i costat Sequent) es calculen automàticament i es mostren en taules separades.",
                    fileFormatLabel: "Fitxer CSV",
                    uploading: "Pujant {{fileName}} i calculant ambdós diffs...",
                },
                review: {
                    fileSummary: "{{fileName}} - Seqüència {{sequence}}, generat {{generatedAt}}",
                    rowFailuresWarning: "{{count}} fila(es) no s'han pogut reconciliar de manera segura i queden excloses d'ambdós diffs - vegeu els detalls a continuació.",
                    noDifferences: "No hi ha diferències - ambdós sistemes ja estan sincronitzats.",
                    diffOnlyDifferences: "Aquesta és una comprovació de convergència d'una seqüència ja aplicada. Les diferències es mostren per fer-ne seguiment, però aquesta ronda no es pot tornar a aplicar.",
                    externalDiffTitle: "Diff extern",
                    sequentDiffTitle: "Diff de Sequent",
                    downloadExternalPatch: "Descarregar pedaç extern",
                    externalDiffCaption: "Descarrega el pedaç i lliura'l al sistema extern fora d'aquesta eina. Un cop l'apliqui i generi el següent fitxer de reconciliació, fes clic a 'Enrere' i deixa anar aquest fitxer - 'Aplicar' s'habilita quan aquesta taula estigui buida.",
                    noExternalDifferences: "No hi ha diferències del costat extern.",
                    sequentDiffCaption: "Aplica els canvis directament a Sequent fent clic a 'Aplicar' - no es genera cap fitxer de pedaç per aquests.",
                    noSequentDifferences: "No hi ha diferències del costat de Sequent.",
                },
                applying: {
                    inProgress: "Aplicant els canvis del costat de Sequent...",
                    rowFailures: "{{count}} fila(es) han quedat excloses d'aquesta ronda i necessiten seguiment manual - vegeu els detalls a continuació.",
                    rowFailuresTruncated: "Es mostren les primeres {{shown}} de {{count}} errades de fila. Resoleu la causa comuna i torneu-ho a provar per veure les errades restants.",
                    success: "Tots els canvis del costat de Sequent s'han aplicat correctament.",
                },
                actions: {
                    cancel: "Cancel·lar",
                    back: "Enrere",
                    apply: "Aplicar",
                    next: "Següent",
                    startOver: "Tornar a començar",
                    close: "Tancar",
                },
                confirm: {
                    title: "Confirmar canvis de reconciliació",
                    categoriesNote: "Les categories ressaltades en taronja ({{categories}}) afecten l'estat de vot o deshabiliten votants.",
                    applyChanges: "Aplicar canvis",
                    continue: "Continuar",
                },
                summary: {
                    votedOtherChannel: "marca {{count}} votant(s) com a votat(s) per un altre canal",
                    disabled: "deshabilita {{count}} votant(s)",
                    reenabled: "rehabilita {{count}} votant(s)",
                    votedUnmarked: "desmarca {{count}} votant(s) com a votat",
                    profileUpdated: "actualitza {{count}} perfil(s)",
                    voterAdded: "afegeix {{count}} votant(s)",
                    prefix: "Això aplicarà canvis que {{parts}}.",
                    empty: "No hi ha canvis del costat de Sequent per aplicar.",
                },
                notifications: {
                    envelopeLoadError: "No s'ha pogut carregar el diff de reconciliació - torna-ho a provar.",
                    generateFailed: "No s'ha pogut calcular el diff de reconciliació - consulta el widget de tasques per a més detalls.",
                    applyFailed: "No s'han pogut aplicar els canvis del costat de Sequent - consulta el widget de tasques per a més detalls.",
                    uploadUrlError: "No s'ha pogut obtenir una URL de pujada",
                    generateTaskError: "No s'ha pogut iniciar la tasca de diff de reconciliació",
                    uploadError: "No s'ha pogut pujar el fitxer de reconciliació",
                    applyTaskError: "No s'ha pogut iniciar la tasca d'aplicació",
                    applyError: "No s'han pogut aplicar els canvis de reconciliació",
                },
            },
        },
        tasksScreen: {
            noPermissions: "No tens permís per accedir als registres.",
            title: "Execució de tasques",
            subtitle: "Informació sobre les tasques executades",
            taskInformation: "Informació de la tasca",
            status: "estat: {{status}}",
            ok: "D'acord",
            column: {
                id: "Índex",
                name: "Nom de la tasca",
                type: "Tipus",
                execution_status: "Estat",
                start_at: "Hora d'inici",
                end_at: "Hora de finalització",
                executed_by_user: "Executor",
                annotations: "Anotacions",
                labels: "Etiquetes",
                logs: "Registres",
            },
            tasksExecution: {
                DELETE_TENANT: "Suprimir organització",
                PUBLISH_BALLOT: "Publicar papereta",
                VOTER_INFORMATION_LETTER: "Carta d'informació per al votant",
                EXPORT_ELECTION_EVENT: "Exportar esdeveniment electoral",
                CREATE_ELECTION_EVENT: "Crear Esdeveniment Electoral",
                IMPORT_ELECTION_EVENT: "Importar esdeveniment electoral",
                IMPORT_USERS: "Importar usuaris",
                EDIT_USER: "Editar votant",
                IMPORT_CANDIDATES: "Importar candidats",
                EXPORT_VOTERS: "Exportar votants",
                CREATE_TRANSMISSION_PACKAGE: "Crear paquet de transmissió",
                EXPORT_BALLOT_PUBLICATION: "Exporta Publicació de Butlleta",
                EXPORT_ACTIVITY_LOGS_REPORT: "Exportar Informe de Registres d'Activitat",
                GENERATE_REPORT: "Generar informe",
                GENERATE_TRANSMISSION_REPORT: "Generar informe de transmissió",
                EXPORT_TRUSTEES: "Exportar Autoritats",
                EXPORT_APPLICATION: "Exportar Sol·licituds",
                EXPORT_TENANT_CONFIG: "Exporta la Configuració del Llogater",
                IMPORT_TENANT_CONFIG: "Importa la Configuració del Llogater",
                RENDER_DOCUMENT_PDF: "Generar el document PDF",
                CREATE_TENANT: "Crear Llogater",
                EXPORT_TEMPLATES: "Exportar plantilles",
                IMPORT_TEMPLATES: "Importar plantilles",
                DELETE_ELECTION_EVENT: "Esborrar esdeveniment electoral",
                DELETE_VOTERS: "Esborrar votants",
                PREPARE_PUBLICATION_PREVIEW: "Preparar la vista prèvia de la publicació",
                EXPORT_TALLY_RESULTS_XLSX: "Exporta els resultats del recompte en format XLSX",
                EXPORT_CERTIFICATE_AUTHORITIES: "Exportar autoritats de certificació",
                PUBLISH_RESULTS_WEBSITE: "Publicar el lloc web de resultats",
            },
            documentAccess: {
                title: "Accés al document",
                sensitivityNotice: "Informació sensible. Compartiu aquesta contrasenya només amb el destinatari previst.",
                passwordLabel: "Contrasenya per obrir el PDF xifrat",
                showPassword: "Mostra la contrasenya",
                copyPassword: "Copia la contrasenya",
                passwordCopied: "Contrasenya copiada",
                passwordError: "No s'ha pogut recuperar la contrasenya del PDF",
                copyError: "No s'ha pogut copiar la contrasenya",
                guidance: "La contrasenya només es carrega després de triar Mostra la contrasenya. Després de carregar-la, aquí apareix un camp de només lectura amb l'opció de copiar.",
            },
            widget: {
                taskTitle: "Tasca: {{title}}",
                viewTask: "Veure Tasca",
                downloadDocument: "Descarregar Fitxer",
            },
            exportTasksExecution: {
                success: "L'exportació s'ha completat amb èxit",
                error: "Error en exportar l'Execució de Tasques",
            },
        },
        logsScreen: {
            noPermissions: "No tens permís per accedir a les bitàcoles.",
            title: "Bitàcoles",
            subtitle: "Bitàcoles generals de les bases de dades principal i de IAM.",
            actions: {
                csv: "Exportar en CSV",
                pdf: "Exportar en PDF",
            },
            exportdialog: {
                description: "Si us plau, confirmeu que voleu executar aquesta acció; pot trigar una estona a completar-se.",
            },
            column: {
                id: "ID",
                statement_kind: "Tipus de declaració",
                created: "Creat",
                statement_timestamp: "Marca de temps de declaració",
                message: "Missatge",
                user_id: "ID d'usuari",
                username: "Nom d'Usuari",
                sender_pk: "Clau primària de l'emissor",
                log_type: "Tipus de registre",
                event_type: "Tipus d'esdeveniment",
                description: "Descripció",
                version: "Versió",
            },
            main: {
                title: "Bitàcola de Base de Dades Principal",
            },
            iam: {
                title: "Bitàcola de Base de Dades de IAM",
            },
        },
        areas: {
            common: {
                title: "Àrees",
                subTitle: "Configuració d'Àrea.",
                deleteError: "Error esborrant Àrea",
            },
            createAreaSuccess: "Àrea creada",
            updateAreaSuccess: "Àrea actualizada",
            createAreaError: "Error creant àrea",
            sequent_backend_area_contest: "Preguntes de l'Àrea",
            empty: {
                header: "No hi ha Àrees encara.",
                action: "Crear una Àrea",
            },
            formImputs: {
                allowEarlyVoting: "Permetre Votació Anticipada",
            },
        },
        integrationsScreen: {
            common: {
                gapiKey: "Clau de Compte de Servei de Google Calendar",
                gapiEmail: "Correu d'Autenticació de Google Calendar",
            },
            errors: {
                invalidGapiKey: "Format de Clau de Compte de Servei de Google Calendar invàlid",
            },
        },
        lookAndFeelScreen: {
            common: {
                helpLinks: "Enllaços d'Ajuda",
                logoUrl: "URL del Logotip",
                css: "CSS Personalitzat",
            },
            errors: {
                invalidHelpLinks: "Format d'Enllaços d'Ajuda invàlid",
            },
        },
        electionTypeScreen: {
            noPermissions: "No tens permís per accedir a la configuració.",
            common: {
                title: "Tipus d'Elecció",
                subtitle: "Configuració del Tipus d'Elecció",
                onlineVoting: "Votació en Línia",
                kioskVoting: "Votació en Quiosc",
                telephoneVoting: "Votació Telefònica",
                settingTitle: "Configuració",
                settingSubtitle: "Ajustos generals",
                sms: "SMS",
                mail: "Correus",
                createNew: "Crear un Tipus d'Elecció",
                emptyHeader: "No hi ha Tipus d'Elecció encara.",
                emptyBody: "Vols crear-ne un?",
            },
            create: {
                title: "Crear Tipus d'Elecció",
            },
            edit: {
                title: "Editar Tipus d'Elecció",
            },
            tabs: {
                votingChannels: "CANALS DE VOTACIÓ",
                electionTypes: "TIPUS D'ELECCIÓ",
                templates: "PLANTILLES",
                localization: "LOCALITZACIÓ",
                languages: "IDIOMES",
                integrations: "INTEGRACIONS",
                lookAndFeel: "PERSONALITZACIÓ D'APARENÇA",
                schedules: "ESDEVENIMENTS PROGRAMATS",
                trustees: "AUTORITATS",
                BackupRestore: "SAUVEGARDE / RESTAURATION",
            },
        },
        trusteesSettingsScreen: {
            common: {
                emptyHeader: "Encara no hi ha fiduciàries.",
                createNew: "Crear fiduciari",
                title: "Fiduciari",
                subtitle: "Configuració del fiduciari",
                emptyBody: "Vols crear-ne un?",
            },
            create: {
                title: "Crear fiduciari",
            },
            edit: {
                title: "Editar fiduciari",
            },
        },
        scheduleScreen: {
            noPermissions: "No tens permís per accedir a la configuració.",
            createScheduleSuccess: "Data creada",
            createScheduleError: "Error creant data",
            deleteScheduleSuccess: "Data esborrada",
            deleteScheduleError: "Error esborrant data",
            common: {
                title: "Programat",
                subtitle: "Configuració de dates",
                createNew: "Crear data",
                emptyHeader: "Encara no hi ha dates.",
                emptyBody: "Vols crear-ne una?",
            },
            create: {
                title: "Crear data",
                selectSchedule: "Seleccioneu un horari de la llista predefinida o escriviu-ne un de personalitzat",
            },
            edit: {
                title: "Editar data",
            },
            eventTypes: {
                SYSTEM_LOCKDOWN_FOR_INTERNET_VOTING_SETTINGS: "Bloqueig del sistema per a la finalització de la configuració de votació per Internet",
                START_PRE_REGISTRATION_OVCS: "Inici de la preinscripció per a OVCS",
                END_PRE_REGISTRATION_OVCS: "Fi de la preinscripció per a OVCS",
                START_TEST_VOTING_PERIOD: "Inici del període de votació de prova",
                END_TEST_VOTING_PERIOD: "Fi del període de votació de prova",
                START_INTERNET_VOTING_PERIOD: "Inici del període de votació per Internet",
                END_INTERNET_VOTING_PERIOD: "Fi del període de votació per Internet",
                LAB_TEST: "Prova de laboratori",
                FIELD_TEST: "Prova de camp",
                MOCK_ELECTIONS: "Eleccions simulades",
                FTS: "FTS",
            },
        },
        dashboard: {
            voteByDay: "Vots per dia",
            votesOverTime: "Vots al llarg del temps",
            timeResolution: "Resolució temporal",
            timeRange: "Interval de temps",
            minute: "Minut",
            hour: "Hora",
            day: "Dia",
            votersByChannels: "Votants per canals",
            voterLoginURL: "URL d'inici de sessió dels votants",
            voterEnrollURL: "URL d'inscripció de votants",
            voterEnrollKioskURL: "Kiosk URL d'inscripció de votants",
            ipAddress: {
                emptyState: "Encara no hi ha vots.",
                title: "Adreces IP",
                ip: "IP",
                country: "País",
                VoteCount: "Nombre de vots",
                ElectionName: "Nom de l'elecció",
                VotersId: "Identificadors dels votants",
            },
        },
        electionEventScreen: {
            common: {
                subtitle: "Configuració de l'Esdeveniment Electoral.",
                showMore: "Mostra'n més",
                showLess: "Mostra'n menys",
                adminPortal: "Portal d'administració",
                allowPublishAfterLockdown: "Permetre la publicació de l'esdeveniment electoral només després del bloqueig",
                reset: "Restablir filtre personalitzat",
            },
            edit: {
                general: "General",
                dates: "Dates",
                customUrls: "Prefix d'URL personalitzats",
                language: "Idiomes",
                votingPeriod: "Període de votació",
                allowed: "Canals de Vot Permesos",
                materials: "Materials de Suport",
                ballotDesign: "Disseny de la Papereta",
                templates: "Plantillas",
                reorder: "Reordenar eleccions",
                advancedConfigurations: "Voting Portal Countdown Policy",
                importCandidates: "Importar Candidats",
                custom_filters: "Filtres personalitzats",
                voter_authentication: "Autenticació del votant",
                realm_attributes: "Atributs del realm de Keycloak",
                realm_attributes_load_error: "Error en carregar els atributs del realm de Keycloak",
                realm_attributes_update_error: "Error en actualitzar els atributs del realm de Keycloak",
                realm_attributes_not_loaded: "Els atributs del realm de Keycloak no s'han carregat; els canvis no s'han desat",
                password_policy: "Política de contrasenyes",
                password_policy_load_error: "Error en carregar la política de contrasenyes de Keycloak",
                password_policy_update_error: "Error en actualitzar la política de contrasenyes de Keycloak",
                password_policy_not_loaded: "La política de contrasenyes de Keycloak no s'ha carregat; els canvis no s'han desat",
            },
            customUrls: {
                login: "Inici de sessió",
                enrollment: "Inscripció",
            },
            localization: {
                emptyHeader: "No s'han establert idiomes per a l'esdeveniment",
                selectLanguage: "Selecciona idioma",
                notify: {
                    success: "La localització s'ha actualitzat correctament",
                    error: "La actualització de la localització ha fallat",
                    duplicateKey: "Ja existeix una substitució amb aquesta clau i àmbit del portal.",
                    invalidDateTimeFormat: "Format de data/hora no vàlid. Utilitza els tokens yyyy, MM, dd, HH, mm, ss (p. ex. dd/MM/yyyy HH:mm).",
                },
                common: {
                    title: "Localització",
                    subTitle: "Configuració de la localització",
                },
                labels: {
                    key: "Clau",
                    scope: "Àmbit del portal",
                    value: "Valor",
                },
                scopes: {
                    legacy: "Anterior ({{portal}})",
                    global: "Global",
                    votingPortal: "Portal de votació",
                    ballotVerifier: "Verificador de paperetes",
                    resultsPortal: "Portal de resultats",
                    adminPortal: "Portal d'administració",
                },
            },
            field: {
                passwordPolicy: {
                    minimumLength: "Longitud mínima",
                    maximumLength: "Longitud màxima",
                    includeUppercase: "Incloure lletres majúscules",
                    includeLowercase: "Incloure lletres minúscules",
                    includeDigits: "Incloure dígits",
                    includeSpecialCharacters: "Incloure caràcters especials",
                    help: {
                        minimumLength: "El nombre mínim de caràcters necessaris per a la contrasenya.",
                        maximumLength: "El nombre màxim de caràcters permesos per a la contrasenya.",
                        includeUppercase: "La contrasenya ha d'incloure almenys una lletra majúscula.",
                        includeLowercase: "La contrasenya ha d'incloure almenys una lletra minúscula.",
                        includeDigits: "La contrasenya ha d'incloure almenys un dígit.",
                        includeSpecialCharacters: "La contrasenya ha d'incloure almenys un caràcter especial.",
                    },
                    notConfigured: "No hi ha cap política de contrasenyes configurada. En desar, s'aplicaran els valors predeterminats següents.",
                    errors: {
                        lengthRange: "Les longituds de la contrasenya han de ser nombres enters entre 1 i 256.",
                        minimumExceedsMaximum: "La longitud mínima no pot superar la longitud màxima.",
                        characterClassRequired: "Seleccioneu almenys una classe de caràcters per a la contrasenya.",
                    },
                },
                name: "Nom",
                alias: "Àlies",
                description: "Descripció",
                startDateTime: "Data i hora d'inici",
                endDateTime: "Data i hora de finalització",
                language: "Idioma",
                votingChannels: "Canals de Vot",
                materialActivated: "Materials de Suport activats",
                supportMaterialsPolicy: {
                    label: "Política de Materials de Suport",
                    helperText: "L'opció Obligatòria per Votar requereix que els votants obrin cada Material de Suport i confirmin que l'han llegit abans de poder votar.",
                    options: {
                        off: "Desactivada",
                        optional: "Opcional",
                        mandatory_for_voting: "Obligatòria per Votar",
                    },
                },
                materialTitle: "Títol",
                materialSubTitle: "Subtítol",
                logoUrl: "URL del Logotip",
                userVerification: "Podeu introduir una plantilla personalitzada que s'utilitzarà per verificar manualment els votants",
                redirectFinishUrl: "URL de redirecció en finalitzar",
                kioskRedirectFinishUrl: "URL de redirecció en finalitzar del quiosc",
                css: "CSS personalitzat",
                skipElectionList: "Saltar pantalla per escollir elecció",
                showUserProfile: "Mostra el perfil de l'usuari",
                showCastVoteLogs: {
                    policyLabel: "Mostra els registres de votació",
                    options: {
                        "show-logs-tab": "Mostra els registres de votació",
                        "hide-logs-tab": "Amaga els registres de votació",
                    },
                },
                lockdownState: {
                    policyLabel: "Estat de Confinament",
                    options: {
                        "locked-down": "Confinat",
                        "not-locked-down": "No Confinat",
                    },
                },
                decodedBallots: {
                    policyLabel: "Inclou les paperetes descodificades a la base de dades de resultats",
                    options: { "included": "Inclou", "not-included": "No incloguis" },
                },
                contestEncryptionPolicy: {
                    options: {
                        "single-contest": "Pregunta única",
                        "multiple-contests": "Diverses preguntes",
                    },
                    policyLabel: "Política de xifrat de pregunta",
                },
                votingPortalDateTimeFormat: {
                    policyLabel: "Format de data i hora del portal de votació",
                    helperText: "S'aplica a tot l'esdeveniment. Per substituir-ho per idioma, afegeix la clau \"votingPortalDateTimeFormat\" a la pestanya Localització amb els tokens yyyy, MM, dd, HH, mm, ss (p. ex. dd/MM/yyyy HH:mm). Consulta la documentació per a més detalls.",
                    options: {
                        "legacy-gb-24h": "GB heretat 24 h (dd/MM/yyyy HH:mm, 24h)",
                        "iso-local": "ISO local (yyyy-MM-dd HH:mm)",
                        "us-12h": "EUA 12 h (MM/dd/yyyy h:mm AM/PM)",
                        "locale-medium": "Locale Medium (data mitjana, hora curta)",
                        "date-only": "Date Only (sense hora)",
                        "custom": "Format personalitzat",
                    },
                    customFormat: {
                        label: "Format de data i hora personalitzat",
                        helperText: "Utilitza els tokens yyyy, MM, dd, HH, mm, ss (p. ex. dd/MM/yyyy HH:mm). Qualsevol altre caràcter es mostra literalment.",
                        invalid: "Format no vàlid. Utilitza almenys un dels tokens yyyy, MM, dd, HH, mm, ss.",
                    },
                },
                countDownPolicyOptions: {
                    NO_COUNTDOWN: "Sense compte enrere",
                    COUNTDOWN: "Compte enrere",
                    COUNTDOWN_WITH_ALERT: "Compte enrere amb avís",
                    sectionTitle: "Portal de votació",
                    policyLabel: "Política de compte enrere del portal de votació",
                    coundownSecondsLabel: "temps en segons abans de la caducitat per mostrar el compte enrere",
                    alertSecondsLabel: "temps en segons abans de la caducitat per mostrar l'avís de tancament de sessió",
                },
                voterSigningPolicy: {
                    "policyLabel": "Política de Signatura de Votants",
                    "no-signature": "Sense signatura",
                    "with-signature": "Amb signatura",
                },
                VoterCertificatePolicy: {
                    policyLabel: "Política de certificat digital del votant",
                    enabled: "Habilitat",
                    disabled: "Deshabilitat",
                },
                enrollment: {
                    policyLabel: "Inscripció",
                    options: {
                        enabled: "Habilitat",
                        disabled: "Deshabilitat",
                    },
                },
                otp: {
                    policyLabel: "OTP",
                    options: {
                        enabled: "Habilitat",
                        disabled: "Deshabilitat",
                    },
                },
                ceremoniesPolicy: {
                    policyLabel: "Política de cerimònies de claus/recompte",
                    options: {
                        "automated-ceremonies": "Permetre cerimònies automàtiques",
                        "manual-ceremonies": "Cerimònies manuals",
                    },
                },
                automaticRecountPolicy: {
                    policyLabel: "Recompte automàtic després d'aprovar una importació",
                    options: {
                        enabled: "Activat",
                        disabled: "Desactivat",
                    },
                },
                weightedVotingPolicy: {
                    policyLabel: "Política de Votació Ponderada",
                    options: {
                        "areas-weighted-voting": "Votació Ponderada per Àrees",
                        "voters-weighted-voting": "Votació Ponderada per Votants",
                        "disabled-weighted-voting": "Votació Ponderada Desactivada",
                    },
                    noDelegated: "La Votació Ponderada per Votants no es pot combinar amb el Vot Delegat",
                    noDecodedBallots: "La Votació Ponderada per Votants no es pot combinar amb la inclusió de paperetes desxifrades als resultats",
                },
                delegatedVotingPolicy: {
                    policyLabel: "Política de Votació Delegada",
                    options: {
                        enabled: "Activada",
                        disabled: "Desactivada",
                    },
                },
                languageDetectionPolicy: {
                    policyLabel: "Política de detecció de llengua",
                    options: {
                        "browser-detect": "Detectar del navegador",
                        "force-default": "Forçar per defecte",
                    },
                },
            },
            error: {
                endDate: "La data de finalització ha de ser posterior a la data d'inici",
                startDate: "La data d'inici ha de ser en el futur",
                noResult: "Encara no hi ha Esdeveniment Electoral",
                endDateInvalid: "La data de finalització ha de ser en el futur",
            },
            voters: {
                title: "Votants",
            },
            createElectionEventSuccess: "Esdeveniment Electoral creat",
            createElectionEventError: "Error creant Esdeveniment Electoral",
            ivr: {
                tabs: {
                    config: "Configuració",
                    blacklist: "Llista de bloqueig",
                    prompts: "Locucions",
                    emulator: "Emulador",
                },
                common: {
                    saveSuccess: "S'ha desat correctament",
                    saveError: "No s'ha pogut desar",
                    deleteSuccess: "S'ha eliminat correctament",
                    deleteError: "No s'ha pogut eliminar",
                },
                config: {
                    configuredPhone: "Número de telèfon configurat",
                    infoMsg: "Configureu el flux de l’IVR i les seves propietats a continuació. Per a més informació, poseu-vos en contacte amb Sequent.",
                },
                prompts: {
                    emptyMsg: "Encara no s’ha creat cap missatge",
                    infoMsg: "Configureu els missatges utilitzats per l’IVR. Els missatges d’anunci són obligatoris, i els missatges del sistema es poden sobreescriure per als idiomes desitjats. S’admet SSML, també per barrejar idiomes.",
                    editorTitle: "Missatge",
                    editorSubtitle: "Configuració del missatge",
                },
                blacklist: {
                    columns: {
                        phone: "Número de telèfon",
                        reason: "Motiu",
                        createdAt: "Creat el",
                        createdBy: "Creat per",
                        createdBefore: "Creat abans",
                        createdAfter: "Creat després",
                    },
                    emptyMsg: "No hi ha cap entrada a la llista de bloqueig",
                    infoMsg: "Configureu la llista de bloqueig de l’IVR. Les trucades d’aquests números seran desconnectades automàticament pel sistema.",
                    noFilterMatch: "Cap entrada no coincideix amb els filtres indicats",
                    phoneRequired: "El número de telèfon és obligatori",
                },
                emulator: {
                    infoMsg: "Seleccioneu una àrea i les eleccions desitjades per provar la sessió IVR.",
                    apiStatus: {
                        unavailable: "El sistema de l'emulador no està disponible al vostre entorn",
                        loading: "S'està carregant el sistema de l'emulador",
                        error: "S'ha produït un error en carregar el sistema de l'emulador",
                    },
                    hints: {
                        title: "Consells",
                        publishRequired: "Qualsevol canvi fet a les eleccions, les preguntes o els candidats s'ha de publicar primer perquè estigui disponible. A l'emulador només s'utilitzaran els estils de papereta publicats més recentment per a l'àrea corresponent.",
                        eventChangesImmediate: "Els canvis fets a l'esdeveniment electoral, com ara la configuració IVR o les substitucions dels missatges, estan disponibles immediatament en reiniciar la sessió de l'emulador.",
                        credentials: 'L\'identificador de votant i el PIN vàlids són "123" i "123".',
                    },
                    sendDtmf: "Envia una entrada DTMF",
                    sendTimeout: "Envia el temps d'espera",
                    disconnected: "Desconnectat",
                    startSession: "Inicia una sessió nova",
                    endSession: "Finalitza la sessió",
                    noStylesFound: "No s'ha trobat cap estil de papereta publicat que coincideixi amb les vostres seleccions",
                    inputPlaceholder: "Introduïu la vostra entrada (màxim de dígits={{maxDigits}}, entrades vàlides={{validInputs}}, temps d'espera={{timeout}} s)",
                    blacklistCaller: "Bloqueja la persona que truca",
                    elections: "Eleccions",
                    area: "Àrea",
                },
            },
            stats: {
                elegibleVoters: "Votants Elegibles",
                voters: "Votants",
                elections: "Eleccions",
                contests: "Preguntes",
                areas: "Àrees",
                sentEmails: "Correus enviats",
                sentSMS: "SMS enviats",
                calendar: {
                    title: "Calendari",
                    scheduled: "Programat",
                },
            },
            keys: {
                createNew: "Crear Cerimònia de Claus",
                emptyHeader: "Encara no hi ha Cerimònia de Claus.",
                statusLabel: "Estat",
                waitingKeys: "Esperant a la Generació de Claus..",
                started: "Iniciada en",
                actions: {
                    participate: "Participa en la cerimònia de claus",
                    view: "Mostra la cerimònia de claus",
                },
                breadCrumbs: {
                    configure: "Configurar",
                    ceremony: "Cerimònia",
                    created: "Acabat",
                    start: "Començament",
                    status: "Estat",
                    download: "Descarregar",
                    check: "Comprovar",
                    success: "Finalitzat",
                },
                notify: {
                    participateNow: "Ha estat convidat a participar a una Cerimònia de Claus. Si us plau <1>feu clic a continuació en l'acció de clau de la cerimònia</1> per participar.",
                },
            },
            tabs: {
                dashboard: "Tauler de Control",
                monitoring: "Monitoratge",
                data: "Dades",
                ivr: "IVR",
                localization: "Localització",
                voters: "Votants",
                areas: "Àrees",
                keys: "Claus",
                tally: "Recompte",
                tallySheetImports: "Importació d'actes",
                publish: "Publicar",
                logs: "Registres",
                tasks: "Tasques",
                events: "Esdeveniment Programat",
                notifications: "Notificacions",
                reports: "Informe",
                approvals: "Aprovacions",
                cas: "Certificats",
            },
            tally: {
                emptyHeader: "Encara no hi ha Recompte.",
                title: "Recompte de l'Esdeveniment Electoral",
                elections: "Eleccions",
                electionNumber: "Número d'Eleccions",
                trustees: "Custodis de claus",
                permissionLabels: "Etiquetes de Permís",
                status: "Estat",
                tallyType: {
                    label: "Tipus de Recompte",
                    ELECTORAL_RESULTS: "Resultats Electorals",
                    INITIALIZATION_REPORT: "Resultats d'Inicialització",
                },
                create: {
                    title: "Crear Recompte",
                    subtitle: "Crear un nou Recompte per a aquest Esdeveniment Electoral",
                    createTallyButton: "Iniciar la Cerimònia de Recompte",
                    createInitializationReportButton: "Crear Informe d'Inicialització",
                    error: {
                        create: "Error creant Recompte",
                    },
                    success: "Recompte creat",
                },
                logs: {
                    noLogs: "No hi ha registres disponibles",
                },
                notify: {
                    noKeysTally: "La Cerimònia del Compte no pot començar fins que la Cerimònia de Fideïcomissaris no s'hagi completat amb èxit.",
                    noPublication: "La Cerimònia de Còmput no pot començar fins que no creïs una publicació a la pestanya Publicar.",
                    participateNow: "Ha estat convidat a participar a una Cerimònia de Recompte. Si us plau <1>feu clic a continuació en l'acció de recompte de la cerimònia</1> per participar.",
                    startDisabled: "No podeu continuar amb la cerimònia perquè no s'ha seleccionat cap elecció o les eleccions no estan publicades.",
                    ceremonyDisabled: "No podeu continuar amb la cerimònia perquè la sessió de recompte no està connectada o l'inici de la cerimònia no està permès.",
                },
            },
            importAreas: {
                title: "Importar Àrees",
                subtitle: "Importar dades d'àrees",
                areaParagraph: "Importar àrees utilitzant un fitxer de full de càlcul en format de valors separats per comes (CSV).",
                importSuccess: "Àrees Importades amb Èxit",
                importError: "Error en importar Àrees",
                upsert: "Inserir o actualitzar àrees",
            },
            import: {
                eetitle: "Importar Esdeveniment Electoral",
                eesubtitle: "Importar dades de l'Esdeveniment Electoral",
                title: "Importar votants",
                subtitle: "Importar votants a l'Esdeveniment Electoral",
                voters: "Votants",
                votersParagraph: "Importa votants utilitzant una fulla de càlcul en format Comma Separated Values (CSV). Descarregueu un exemple de fitxer d'importació CSV aquí.",
                electionEventParagraph: "Importa Esdeveniments Electorals utilitzant un fitxer JSON.",
                elections: "Eleccions",
                areas: "Àrees",
                sha: "Verificació d'Integritat (SHA 256)",
                cancel: "Cancel·lar",
                import: "Importar",
                fileUploadSuccess: "Fitxer pujat al servidor - però no importat encara",
                fileUploadError: "Error pujant el fitxer",
                importVotersSuccess: "Importació de Votants llançada en segon pla amb èxit.",
                importVotersError: "Error Important Votants.",
                importElectionEventSuccess: "Esdeveniment electoral importat correctament",
                importElectionEventError: "Error en importar l'esdeveniment electoral",
                shaDialog: {
                    ok: "Sí, Importar Sense Verificació d'Integritat",
                    cancel: "Tornar",
                    title: "Importar Sense Verificació d'Integritat?",
                    description: "No va introduir el camp Verificació d'integritat (SHA-256). Confirmeu que està importanr el fitxer correcte i que desitja importar-lo.",
                },
                passwordDialog: {
                    title: "Contrasenya de Desxifrat",
                    description: "Introdueix la contrasenya per desxifrar l'arxiu",
                    label: "Contrasenya",
                    copyPassword: "Copiar Contrasenya",
                    ok: "D'acord",
                },
            },
            export: {
                title: "Exportar Esdeveniment Electoral",
                subtitle: "L'exportació pot ser una operació llarga. Estàs segur que vols exportar els registres?",
                encryptWithPassword: "Xifrar amb Contrasenya",
                passwordForcedNote: "L'arxiu es protegirà amb contrasenya igualment: els informes, les sol·licituds i les dades del tauler sempre es xifren. Marca la casella per incloure també els camps secrets de votant desxifrats.",
                includeVoters: "Incloure Votants",
                activityLogs: "Registres d'Activitat",
                bulletinBoard: "Tauler d'Anuncis",
                publications: "Publicacions",
                s3Files: "Fitxers S3",
                scheduledEvents: "Esdeveniments Programats",
                exportSuccess: "Esdeveniment Electoral exportat amb èxit",
                exportError: "Error en exportar l'Esdeveniment Electoral",
                passwordTitle: "Contrasenya",
                passwordDescription: "Contrasenya per desxifrar el fitxer:",
                copiedSuccess: "Contrasenya copiada al porta-retalls",
                copiedError: "Error copiant la contrasenya",
                reports: "Informes",
                applications: "Aplicacions",
                tally: "Recompte",
                certificates: "Certificats",
            },
            taskNotification: "{{action}} ha començat. Podeu veure el seu estat a la taula d'Execució de Tasques.",
        },
        electionScreen: {
            common: {
                title: "Elecció",
                subtitle: "Configuració de l'elecció.",
                fileLoaded: "Fitxer carregat",
                noPermission: "No tens permís per accedir a aquesta elecció.",
            },
            edit: {
                general: "General",
                dates: "Dates",
                votingPeriod: "Període de votació",
                language: "Idioma",
                allowed: "Canals de Vot Permesos",
                default: "Per defecte",
                defaultLang: "Idioma per defecte",
                receipts: "Rebuts",
                image: "Imatge",
                advanced: "Configuració Avançada",
                numAllowedVotes: "Número de vots permesos",
                reorder: "Reordenar preguntes",
                castVoteConfirm: "Modal de Confirmació de Vot",
                gracePeriodPolicy: "Política de període de gràcia",
                allowTallyPolicy: "Permetre recompte",
                permissionLabel: "Etiqueta de permís",
                custom_filters: "Filtres personalitzats",
            },
            field: {
                name: "Nom",
                language: "Idioma",
                votingChannels: "Canals de Vot",
                startDateTime: "Data i hora d'inici",
                endDateTime: "Data i hora de finalització",
                startDateTimeWithTimezone: "Data i hora d'inici ({{timezone}})",
                endDateTimeWithTimezone: "Data i hora de finalització ({{timezone}})",
                scheduledOpening: "Obertura Programada",
                scheduledClosing: "Tancament Programat",
                alias: "Àlies",
                description: "Descripció",
                securityConfirmationHtml: "Confirmació de seguretat HTML",
                ivrPrompt: "Missatge IVR",
                externalId: "ID extern",
            },
            securityConfirmationPolicy: {
                label: "Política de la casella de confirmació de seguretat",
                none: "Cap",
                mandatory: "Obligatori",
            },
            error: {
                fileError: "Error al carregar el fitxer",
                fileLoaded: "Fitxer carregat",
                endDate: "La data de finalització ha de ser posterior a la data d'inici",
                startDate: "La data d'inici ha de ser en el futur",
                endDateInvalid: "La data de finalització ha de ser en el futur",
            },
            createElectionEventSuccess: "Creada l'elecció",
            createElectionEventError: "Error Creant l'elecció",
            tabs: {
                dashboard: "Tauler de Control",
                monitoring: "Monitoratge",
                data: "Dades",
                voters: "Votants",
                publish: "Publicar",
                logs: "Registres",
                approvals: "Aprovacions",
                tallySheets: "Fulls de recompte",
            },
            gracePeriodPolicy: {
                "label": "Política de període de gràcia",
                "no-grace-period": "Sense període de gràcia",
                "grace-period-without-alert": "Període de gràcia sense avís",
                "gracePeriodSecs": "Període de gràcia (segons)",
            },
            allowTallyPolicy: {
                "allowed": "Permès",
                "disallowed": "No Permès",
                "requires-voting-period-end": "Requereix el final del període de votació",
            },
            initializeReportPolicy: {
                "label": "Inicialitzar política d'informes",
                "not-required": "No requereix",
                "required": "Requerit",
            },
            castVoteGoldLevelPolicy: {
                label: "Política d'autenticació de nivell or",
                options: {
                    "gold-level": "Autenticació de nivell or",
                    "no-gold-level": "Sense autenticació de nivell or",
                },
            },
            slates: {
                enable: {
                    label: "Habilita les candidatures",
                    helper: "Si està habilitat, els votants poden triar una candidatura amb nom i canviar qualsevol contesa, inclosos els candidats independents.",
                },
                disable: {
                    confirm: "Deshabilita les candidatures",
                    message_one: "Aquesta elecció té {{count}} candidatura. Si deshabilites les candidatures, s'eliminarà en desar.",
                    message_many: "Aquesta elecció té {{count}} candidatures. Si deshabilites les candidatures, s'eliminaran en desar.",
                    message_other: "Aquesta elecció té {{count}} candidatures. Si deshabilites les candidatures, s'eliminaran en desar.",
                },
                mobileCandidateLists: {
                    label: "Llistes de candidats al mòbil",
                    helper: "Com apareix inicialment la llista de candidats de cada candidatura al mòbil: Replegades o Desplegades. Els votants sempre poden obrir o tancar qualsevol llista. A l'escriptori sempre es mostren tots els candidats.",
                    options: {
                        collapsed: "Replegades",
                        expanded: "Desplegades",
                    },
                },
            },
            startScreenTitlePolicy: {
                label: "Política de títol de la pantalla d'inici",
                options: {
                    "election": "Títol de l'elecció",
                    "election-event": "Títol de l'esdeveniment electoral",
                },
            },
            consolidatedReportPolicy: {
                label: "Política d'informe consolidat",
                options: {
                    "generate": "Generar",
                    "do-not-generate": "No generar",
                },
            },
            declineToVotePolicy: {
                label: "Política de declinació de vot",
                options: {
                    enabled: "Habilitat",
                    disabled: "Desactivat",
                },
            },
            blankBallotsPolicy: {
                label: "Política de paperetes en blanc",
                options: {
                    enabled: "Habilitat",
                    disabled: "Desactivat",
                },
            },
            votingScreenBackPolicy: {
                label: "Política del botó Enrere de la pantalla de votació",
                options: {
                    "election-selection-screen": "Vés a la pantalla de selecció d'eleccions",
                    "start-screen": "Vés a la pantalla d'inici de l'elecció",
                },
            },
        },
        tenantScreen: {
            common: {
                title: "Llogaters",
            },
            new: {
                subtitle: "Crear nou llogater",
            },
            createSuccess: "Llogater creat",
            createError: "Error en crear el llogater",
        },
        usersAndRolesScreen: {
            noPermissions: "No tens permís per accedir als usuaris o rols.",
            common: {
                title: "Usuaris i Rols",
                subtitle: "Configuració general",
                mobileNumber: "Mòbil",
            },
            editPassword: {
                passwordPolicyViolation: "La contrasenya no compleix la Política de contrasenyes d'aquest esdeveniment electoral. Reviseu la política a Dades de l'esdeveniment electoral i introduïu una contrasenya vàlida.",
                passwordPolicyRules: {
                    minimumLength: "La longitud mínima de la contrasenya és {{count}}.",
                    maximumLength: "La longitud màxima de la contrasenya és {{count}}.",
                    uppercase: "Caràcters en majúscula necessaris: {{count}}.",
                    lowercase: "Caràcters en minúscula necessaris: {{count}}.",
                    digits: "Dígits necessaris: {{count}}.",
                    specialCharacters: "Caràcters especials necessaris: {{count}}.",
                },
                label: "Canviar contrasenya",
                temporatyLabel: "Temporal",
                temporatyInfo: "Si està habilitat, l'usuari haurà de canviar la contrasenya en el pròxim inici de sessió.",
            },
            users: {
                title: "Usuaris",
                subtitle: "Veure i editar dades de l'usuari",
                review: {
                    title: "Revisar canvis",
                    subtitle: "Confirma aquestes actualitzacions abans d'enviar-les.",
                    confirm: "Confirmar canvis",
                    noChanges: "No hi ha canvis per revisar",
                    field: "Camp",
                    currentValue: "Valor actual",
                    newValue: "Valor nou",
                },
                edit: {
                    title: "Informació de l'Usuari",
                    subtitle: "Veure i editar Usuari",
                },
                create: {
                    title: "Usuari",
                    subtitle: "Crear usuari",
                },
                fields: {
                    "has_voted": "Ha votat",
                    "support_materials_viewed": "Materials de Suport vistos",
                    "vote-weight": "Pes del vot",
                    "voted-channel": "Canal de vot",
                    "disable-comment": "Comentari de desactivació",
                    "username": "Nom d'Usuari",
                    "first_name": "Nom",
                    "last_name": "Cognom",
                    "email": "Correu",
                    "enabled": "Habilitat",
                    "emailVerified": "Correu Verificat",
                    "groups": "Grups",
                    "attributes": "Atributs",
                    "area": "Àrea",
                    "password": "Contrasenya",
                    "savePassword": "Desa la contrasenya",
                    "repeatPassword": "Repetir Contrasenya",
                    "passwordMismatch": "Les contrasenyes han de coincidir",
                    "passwordLengthValidate": "La contrasenya ha de tenir almenys 8 caràcters",
                    "passwordUppercaseValidate": "La contrasenya ha de contenir almenys una lletra majúscula",
                    "passwordLowercaseValidate": "La contrasenya ha de contenir almenys una lletra minúscula",
                    "passwordDigitValidate": "La contrasenya ha de contenir almenys un dígit",
                    "passwordSpecialCharValidate": "La contrasenya ha de contenir almenys un caràcter especial",
                    "trustee": "Actuar com a fideïcomissari",
                    "permissionLabel": "Etiqueta de permís",
                    "authorized-election-ids": "Eleccions",
                },
                delete: {
                    body: "Estàs segur que vols esborrar aquest usuari?",
                    bulkBody: "Estàs segur que vols esborrar els usuaris seleccionats?",
                    bulkBodySelected: "Vols esborrar els {{count}} usuaris seleccionats? Aquesta acció no es pot desfer.",
                    bulkBodyChoose: "Hi ha {{count}} usuaris seleccionats. En lloc d'això, pots esborrar tots els usuaris que coincideixen amb els filtres actuals, que poden ser més. Aquesta acció no es pot desfer.",
                    okSelected: "Esborrar {{count}} seleccionats",
                    okAllMatching: "Esborrar tots els coincidents",
                },
                notifications: {
                    exportError: "Error exportant usuaris",
                    deleteError: "Error esborrant usuari",
                    deleteSuccess: "Usuari esborrat",
                    multipleDeleteSuccess: "Usuaris esborrats",
                },
            },
            voters: {
                voterInformationLetter: {
                    label: "Carta d'informació per al votant",
                    generate: "Genera",
                    confirmation: "Voleu generar una Carta d'informació per a aquest votant? S'assignarà una contrasenya nova i s'inclourà en un PDF xifrat.",
                    generationStarted: "S'ha iniciat la generació de la Carta d'informació",
                    generationError: "No s'ha pogut generar la Carta d'informació",
                    policyNotConfigured: "La Política de contrasenyes no està configurada. Configureu-la a Dades de l'esdeveniment electoral abans de generar una carta.",
                    policyMinimumLengthMissing: "La Política de contrasenyes ha d'incloure una longitud mínima abans de generar una carta.",
                    policyCharacterClassMissing: "La Política de contrasenyes ha d'incloure almenys una classe de caràcters abans de generar una carta.",
                },
                title: "Votants",
                subtitle: "Veure i editar dades del votant",
                secretAttribute: {
                    storedPlaceholder: "Valor xifrat emmagatzemat",
                    reveal: "Mostra",
                    hide: "Amaga",
                    revealError: "No s'ha pogut mostrar el camp xifrat del votant",
                    includeInExport: "Inclou els camps secrets desxifrats del votant",
                    exportWarning: "Exportació sensible: el CSV descarregat contindrà aquests camps en text pla.",
                    clear: "Esborra",
                    add: "Afegeix un valor",
                    remove: "Elimina el valor",
                },
                review: {
                    title: "Revisar canvis",
                    subtitle: "Confirma aquestes actualitzacions abans d'enviar-les.",
                    confirm: "Confirmar canvis",
                    noChanges: "No hi ha canvis per revisar",
                    field: "Camp",
                    currentValue: "Valor actual",
                    newValue: "Valor nou",
                },
                logs: {
                    label: "Registres de l'usuari",
                },
                emptyHeader: "Encara no hi ha votant.",
                askCreate: "Vols crear-ne un?",
                create: {
                    title: "Votant",
                    subtitle: "Crear votant",
                },
                manualVerification: {
                    label: "Verificar manualment",
                    verify: "Verificar manualment al votant",
                    body: "Verifiqueu manualment a aquest votant. Obtindrà un PDF amb un enllaç de codi QR que permet al votant iniciar sessió ometent el KYC en línia.",
                    noEmailOrPhone: "Aquest votant no pot ser verificat manualment perquè no té una adreça de correu electrònic o un número de telèfon assignat.",
                },
                errors: {
                    editError: "Error editant votant",
                    editErrorReason: "Error editant votant: {{reason}}",
                    editSuccess: "Votant editat",
                    createError: "Error creant votant",
                    createErrorReason: "Error creant votant: {{reason}}",
                    createSuccess: "Votant creat",
                    attribute: {
                        invalidNamed: 'S\'ha rebutjat "{{field}}": {{constraint}}',
                        fieldsToCorrect: "Alguns camps s'han de corregir abans de desar",
                        hintBetween: "Entre {{min}} i {{max}} caràcters",
                        hintMin: "Com a mínim {{min}} caràcters",
                        hintMax: "Com a màxim {{max}} caràcters",
                        andMore: "i {{count}} més",
                        invalidLength: '"{{field}}" ha de tenir entre {{min}} i {{max}} caràcters',
                        tooShort: '"{{field}}" ha de tenir com a mínim {{min}} caràcters',
                        tooLong: '"{{field}}" ha de tenir com a màxim {{max}} caràcters',
                        required: '"{{field}}" és obligatori',
                        invalidEmail: '"{{field}}" ha de ser una adreça de correu electrònic vàlida',
                        invalidFormat: '"{{field}}" no té el format esperat',
                        invalid: '"{{field}}" té un valor no vàlid',
                    },
                    createPasswordError: "Votant creat, però no s'ha pogut establir la seva contrasenya",
                    createPasswordErrorReason: "Votant creat, però no s'ha pogut establir la seva contrasenya: {{reason}}",
                },
                delete: {
                    body: "Estàs segur que vols esborrar aquest votant?",
                    bulkBody: "Estàs segur que vols esborrar els votants seleccionats?",
                    bulkBodySelected: "Vols esborrar els {{count}} votants seleccionats? Aquesta acció no es pot desfer.",
                    bulkBodyChoose: "Hi ha {{count}} votants seleccionats. En lloc d'això, pots esborrar tots els votants que coincideixen amb els filtres actuals, que poden ser més. Aquesta acció no es pot desfer.",
                    okSelected: "Esborrar {{count}} seleccionats",
                    okAllMatching: "Esborrar tots els coincidents",
                },
                notifications: {
                    exportError: "Error exportant votants",
                    deleteError: "Error esborrant votant",
                    deleteSuccess: "Votant esborrat",
                    multipleDeleteSuccess: "Votants esborrats",
                    manualVerificationError: "Error verificant manualment al votant",
                    manualVerificationSuccess: "Verificat amb èxit manualment al votant, descarregar PDF..",
                },
            },
            roles: {
                title: "Rols",
                edit: {
                    title: "Informació del Rol",
                    subtitle: "Veure i editar Rol",
                },
                create: {
                    title: "Rol",
                    subtitle: "Crear rol",
                },
                errors: {
                    createError: "Error creant rol",
                    createSuccess: "Rol creat",
                },
                fields: {
                    name: "Nom",
                },
                delete: {
                    body: "Estàs segur que vols esborrar aquest rol?",
                },
                notifications: {
                    deleteError: "Error esborrant rol",
                    deleteSuccess: "Rol esborrat",
                    permissionEditError: "Error editant permís",
                    permissionEditSuccess: "Permís editat",
                },
            },
            permissions: {
                "voter-information-letter": "Genera una Carta d'informació per al votant",
                "admin-user": "Administració",
                "admin-dashboard-view": "Vista del Tauler d'Administració",
                "application-export": "Exportació d'Aplicacions",
                "application-import": "Importació d'Aplicacions",
                "tenant-create": "Crear Inquilí",
                "tenant-read": "Llegir Inquilí",
                "tenant-write": "Editar Inquilí",
                "tenant-delete": "Esborrar Inquilí",
                "election-event-create": "Crear Esdeveniment Electoral",
                "election-event-read": "Llegir Esdeveniment Electoral",
                "election-event-write": "Editar Esdeveniment Electoral",
                "keycloak-realm-attributes-read": "Llegir atributs del realm de Keycloak",
                "keycloak-realm-attributes-write": "Editar atributs del realm de Keycloak",
                "election-event-delete": "Esborrar Esdeveniment Electoral",
                "voter-create": "Crear Votant",
                "voter-read": "Llegir Votant",
                "voter-write": "Editar Votant",
                "voter-secret-attribute-read": "Mostrar Camps Secrets del Votant",
                "voter-secret-attribute-write": "Editar Camps Secrets del Votant",
                "user-create": "Crear Usuari",
                "user-read": "Llegir Usuari",
                "user-write": "Editar Usuari",
                "user-permission-create": "Crear Permís d'Usuari",
                "user-permission-read": "Llegir Permís d'Usuari",
                "user-permission-write": "Editar Permís d'Usuari",
                "role-create": "Crear Rol",
                "role-read": "Llegir Rol",
                "role-write": "Editar Rol",
                "role-assign": "Assignar Rol",
                "communication-template-create": "Crear Plantilla de Comunicació",
                "communication-template-read": "Llegir Plantilla de Comunicació",
                "communication-template-write": "Editar Plantilla de Comunicació",
                "notification-read": "Llegir Notificació",
                "notification-write": "Editar Notificació",
                "notification-send": "Enviar Notificació",
                "area-read": "Llegir Àrea",
                "area-write": "Editar Àrea",
                "election-state-write": "Editar Estat d'Elecció",
                "election-type-create": "Crear Tipus d'Elecció",
                "election-type-read": "Llegir Tipus d'Elecció",
                "election-type-write": "Editar Tipus d'Elecció",
                "voting-channel-read": "Llegir Canal de Votació",
                "voting-channel-write": "Editar Canal de Votació",
                "trustee-create": "Crear Fideïcomissari",
                "trustee-read": "Llegir Fideïcomissari",
                "trustee-write": "Editar Fideïcomissari",
                "tally-read": "Llegir Recompte",
                "tally-start": "Iniciar Recompte",
                "tally-write": "Editar Recompte",
                "tally-results-read": "Llegir Resultats de Recompte",
                "publish-read": "Llegir Publicació",
                "publish-write": "Editar Publicació",
                "publish-results-read": "Llegir Publicació de Resultats",
                "publish-results-write": "Editar Publicació de Resultats",
                "logs-read": "Llegir Registres",
                "tasks-read": "Llegir l'Execució de Tasques",
                "keys-read": "Llegir Claus",
                "document-upload": "Pujar Documents",
                "document-download": "Descarregar Documents",
                "document-password-read": "Llegir contrasenyes de documents",
                "tally-sheet-create": "Crear Acta de Recompte",
                "tally-sheet-import-create": "Crear importació d'actes de recompte",
                "tally-sheet-import-review": "Revisar importació d'actes de recompte",
                "tally-sheet-import-view": "Veure importació d'actes de recompte",
                "tally-recount-execute": "Executar recompte de resultats",
                "trustee-ceremony": "Cerimònia de Fideïcomissari",
                "tally-sheet-review": "Revisar full de recompte",
                "tally-sheet-view": "Veure Acta de Recompte",
                "admin-ceremony": "Administrar Cerimònia de Claus",
                "tally-sheet-delete": "Esborrar Acta de Recompte",
                "cast-vote-read": "Llegir Vots Emissos",
                "document-read": "Llegir Documents",
                "document-write": "Editar Documents",
                "support-material-read": "Llegir Materials de Suport",
                "support-material-write": "Editar Materials de Suport",
                "miru-create": "Crear Miru",
                "miru-download": "Descarregar Miru",
                "miru-send": "Enviar Miru",
                "miru-sign": "Signar Miru",
                "contest-write": "Editar Pregunta",
                "contest-read": "Llegir Pregunta",
                "candidate-write": "Editar Candidats",
                "candidate-read": "Llegir Candidats",
                "permission-label-write": "Edita l'etiqueta de permís",
                "scheduled-event-write": "Editar Esdeveniments Programats",
                "contest-create": "Crear Pregunta",
                "contest-delete": "Esborrar Pregunta",
                "candidate-create": "Crear Candidat",
                "candidate-delete": "Esborrar Candidat",
                "election-create": "Crear Election",
                "election-read": "Llegir Elecció",
                "election-write": "Editar Elecció",
                "election-delete": "Esborrar Elecció",
                "election-event-archive": "Arxivar Event Electoral",
                "election-data-tab": "Veure Dades de l'Elecció",
                "election-event-areas-tab": "Veure Àrees de l'Esdeveniment Electoral",
                "election-event-data-tab": "Veure Dades de l'Esdeveniment Electoral",
                "election-event-keys-tab": "Veure Claus de l'Esdeveniment Electoral",
                "election-event-logs-tab": "Veure Registres de l'Esdeveniment Electoral",
                "election-event-publish-tab": "Veure Publicació de l'Esdeveniment Electoral",
                "election-event-reports-tab": "Veure Informes de l'Esdeveniment Electoral",
                "election-event-scheduled-tab": "Veure Programació de l'Esdeveniment Electoral",
                "election-event-tally-tab": "Veure Recompte de l'Esdeveniment Electoral",
                "election-event-tasks-tab": "Veure Tasques de l'Esdeveniment Electoral",
                "election-event-voters-tab": "Veure Votants de l'Esdeveniment Electoral",
                "election-publish-tab": "Veure Publicació de l'Elecció",
                "election-voters-tab": "Veure Votants de l'Elecció",
                "report-write": "Editar Informes",
                "report-read": "Llegir Informes",
                "users-menu": "Veure usuaris i rols",
                "settings-menu": "Veure configuració",
                "templates-menu": "Veure plantilles",
                "settings-election-types-tab": "Veure configuració de tipus d'elecció",
                "settings-voting-channels-tab": "Veure configuració de canals de votació",
                "settings-templates-tab": "Veure configuració de plantilles",
                "settings-languages-tab": "Veure configuració d'idiomes",
                "settings-localization-tab": "Veure configuració de localització",
                "settings-look-feel-tab": "Veure configuració d'aparença",
                "settings-trustees-tab": "Veure configuració de fideïcomissaris",
                "settings-countries-tab": "Veure configuració de països",
                "voter-import": "Importar Votant",
                "ee-voters-columns": "Veure Columnes de Votants de l'Esdeveniment Electoral",
                "voter-manually-verify": "Verificar Votant Manualment",
                "ee-voters-logs": "Veure Registres de Votants de l'Esdeveniment Electoral",
                "voter-export": "Exportar Votant",
                "ee-voters-filters": "Veure Filtres de Votants de l'Esdeveniment Electoral",
                "voter-delete": "Eliminar Votant",
                "voter-change-password": "Canviar la Contrasenya del Votant",
                "election-event-localization-selector": "Selector de Localització de l'Esdeveniment Electoral",
                "localization-create": "Crear Localització",
                "localization-read": "Llegir Localització",
                "localization-write": "Editar Localització",
                "localization-delete": "Eliminar Localització",
                "area-create": "Crear Àrea",
                "area-delete": "Eliminar Àrea",
                "area-export": "Exportar Àrea",
                "area-import": "Importar Àrea",
                "area-upsert": "Inserir o Actualitzar Àrea",
                "election-event-areas-columns": "Columnes de les Àrees de l'Esdeveniment Electoral",
                "election-event-areas-filters": "Filtres de les Àrees de l'Esdeveniment Electoral",
                "election-event-tasks-back-button": "Tornar a les Tasques de l'Esdeveniment Electoral",
                "election-event-tasks-columns": "Columnes de les Tasques de l'Esdeveniment Electoral",
                "election-event-tasks-filters": "Filtres de les Tasques de l'Esdeveniment Electoral",
                "task-export": "Exportar Tasques",
                "application-read": "Llegir Aplicació",
                "application-write": "Editar Aplicació",
                "logs-export": "Exportar Registres",
                "election-event-logs-columns": "Columnes dels Registres de l'Esdeveniment Electoral",
                "election-events-logs-filters": "Filtres dels Registres de l'Esdeveniment Electoral",
                "election-event-scheduled-event-columns": "Columnes dels Esdeveniments Programats de l'Esdeveniment Electoral",
                "scheduled-event-create": "Crear Esdeveniment Programat",
                "scheduled-event-delete": "Eliminar Esdeveniment Programat",
                "election-event-reports-columns": "Columnes dels Informes de l'Esdeveniment Electoral",
                "report-create": "Crear Informe",
                "report-delete": "Eliminar Informe",
                "report-generate": "Generar Informe",
                "report-preview": "Vista Prèvia de l'Informe",
                "monitor-authenticated-voters": "Monitoreig de Votants Autenticats",
                "monitor-all-approve-disapprove-voters": "Llegir Monitoreig de Votants Aprovat i Rebutjat",
                "monitor-automatic-approve-disapprove-voters": "Llegir Monitoreig d'Aprovacions i Rebutjos Automàtics",
                "monitor-manually-approve-disapprove-voters": "Llegir Monitoreig d'Aprovacions i Rebutjos Manuals",
                "monitor-enrolled-overseas-voters": "Llegir Monitoreig de Votants Registrats a l'Estranger",
                "monitor-posts-already-closed-voting": "Llegir Monitoreig de Publicacions amb Votació Tancada",
                "monitor-posts-already-generated-election-results": "Llegir Monitoreig de Publicacions amb Resultats Generats",
                "monitor-posts-already-opened-voting": "Llegir Monitoreig de Publicacions amb Votació Oberta",
                "monitor-posts-already-started-counting-votes": "Llegir Monitoreig de Publicacions que Han Començat a Comptar Vots",
                "monitor-posts-initialized-the-system": "Llegir Monitoreig de Publicacions que Han Inicialitzat el Sistema",
                "monitor-posts-started-voting": "Llegir Monitoreig de Publicacions que Han Començat a Votar",
                "monitor-posts-transmitted-results": "Llegir Monitoreig de Publicacions que Han Transmès Resultats",
                "monitor-voters-voted-test-election": "Llegir Monitoreig de Votants a l'Elecció de Prova",
                "monitor-voters-who-voted": "Llegir Monitoreig de Votants que Han Votat",
                "election-event-publish-preview": "Vista Prèvia de la Publicació de l'Esdeveniment Electoral",
                "election-event-publish-back-button": "Tornar a la Publicació de l'Esdeveniment Electoral",
                "election-event-publish-columns": "Columnes de la Publicació de l'Esdeveniment Electoral",
                "election-event-publish-filters": "Filtres de la Publicació de l'Esdeveniment Electoral",
                "publish-create": "Crear Publicació",
                "publish-regenerate": "Regenerar Publicació",
                "publish-export": "Exportar Publicació",
                "publish-start-voting": "Iniciar Votació",
                "publish-pause-voting": "Pausar Votació",
                "publish-stop-voting": "Aturar Votació",
                "publish-changes": "Publicar Canvis",
                "election-event-publish-view": "Veure la Publicació de l'Esdeveniment Electoral",
                "election-event-keys-columns": "Columnes de les Claus de l'Esdeveniment Electoral",
                "create-ceremony": "Crear Cerimònia",
                "export-ceremony": "Exportar Cerimònia",
                "election-event-tally-columns": "Columnes del Recompte de l'Esdeveniment Electoral",
                "election-event-tally-back-button": "Tornar al Recompte de l'Esdeveniment Electoral",
                "transmition-ceremony": "Cerimònia de Transmissió",
                "admin-ip-address-view": "Veure Adreça IP",
                "election-approvals-tab": "Veure Aprovacions d'Elecció",
                "election-event-approvals-tab": "Veure Aprovacions de l'Esdeveniment Electoral",
                "election-ip-address-view": "Veure Adreça IP d'Elecció",
                "election-dashboard-tab": "Veure Panell de Monitoreig d'Elecció",
                "trustees-export": "Exportar Fideïcomissaris",
                "user-import": "Importar Usuaris",
                "voter-voted-edit": "Edita els votants que han votat",
                "voter-email-tlf-edit": "Edita els camps de correu electrònic/telèfon dels votants",
                "cloudflare-write": "Edita les regles de bloqueig per país a Cloudflare",
                "transmission-report-generate": "Generar Informe de Transmissió",
                "google-meet-link": "Generar Enllaç de Google Meet",
                "service-account": "Compte de servei",
                "datafix-account": "Compte de correcció de dades",
                "gold": "Or",
                "silver": "Plata",
                "election-event-ivr-tab": "Mostra l’IVR de l’esdeveniment electoral",
                "election-event-cas-tab": "Mostra el CAS de l’esdeveniment electoral",
                "ca-read": "Consulta les autoritats de certificació",
                "ca-write": "Edita les autoritats de certificació",
                "generate-preview": "Genera la previsualització",
                "preview-read": "Consulta la previsualització",
                "tally-resolution-submit": "Envia la resolució del recompte",
                "phone-blacklist-read": "Consulta la llista negra de telèfons",
                "phone-blacklist-create": "Crea entrades a la llista negra de telèfons",
                "phone-blacklist-update": "Edita entrades de la llista negra de telèfons",
                "phone-blacklist-delete": "Suprimeix entrades de la llista negra de telèfons",
                "election-event-voter-list-reconciliation": "Concilia la llista de votants de l’esdeveniment electoral",
            },
        },
        generalSettingsScreen: {
            body: "Activeu els idiomes al sistema. Només els idiomes activats aquí estaran disponibles per a esdeveniments electorals.",
        },
        eventsScreen: {
            title: "Esdeveniments Programats",
            subtitle: "Gestiona la configuració de l'execució automàtica d'esdeveniments com l'inici o el final del període de votació.",
            messages: {
                createSuccess: "Esdeveniment Programat creat amb èxit",
                createError: "Error en crear l'Esdeveniment Programat",
                editSuccess: "Esdeveniment Programat editat amb èxit",
                editError: "Error en editar l'Esdeveniment Programat",
                onlineWithEarlyVoting: "Una programació d'inici no pot obrir alhora el vot en línia i el vot anticipat: el vot anticipat ha de començar abans que el vot en línia.",
            },
            eventType: {
                label: "Tipus",
                ALLOW_INIT_REPORT: "Permetre informe d'inicialització",
                START_VOTING_PERIOD: "Inici del Període de Votació",
                END_VOTING_PERIOD: "Final del Període de Votació",
                ALLOW_VOTING_PERIOD_END: "Permetre el final del període de votació",
                START_ENROLLMENT_PERIOD: "Inici del període de matrícula",
                END_ENROLLMENT_PERIOD: "Finalització del període de matrícula",
                START_LOCKDOWN_PERIOD: "Inici del Período de Bloc de Dades Censals",
                END_LOCKDOWN_PERIOD: "Final del Período de Bloc de Dades Censals",
                ALLOW_TALLY: "Permetre el recompte",
            },
            election: {
                label: "Elecció",
            },
            empty: {
                header: "Encara no hi ha Esdeveniments Programats.",
                body: "Voleu crear-ne un?",
                button: "Crear Esdeveniment Programat",
            },
            create: {
                title: "Crear Esdeveniment Programat",
                subtitle: "Crea una nova configuració d'Esdeveniment Programat.",
            },
            edit: {
                title: "Editar Esdeveniment Programat",
                subtitle: "Edita la configuració de l'Esdeveniment Programat.",
                delete: "Esteu segur que voleu suprimir aquest Esdeveniment Programat?",
            },
            fields: {
                electionId: "Elecció",
                eventProcessor: "Tipus",
                stoppedAt: "Aturat A",
                scheduledDate: "Programat A",
            },
        },
        reportsScreen: {
            title: "Informes",
            subtitle: "Generar informes per als esdeveniments electorals",
            messages: {
                createSuccess: "Informe creat amb èxit",
                createError: "Error en crear l'informe",
                submitError: "Error en enviar l'Informe",
                updateSuccess: "Informe actualitzat amb èxit",
                passwordMismatch: "La contrasenya i la confirmació no coincideixen. Assegura't que tots dos camps continguin la mateixa contrasenya.",
                incorectPassword: "Contrasenya incorrecta",
                decryptFileTitle: "Desxifrar arxiu",
                decryptInstructions: "1. '-in': La ruta al fitxer xifrat. \n2. '-out': La ruta on es desarà el fitxer desxifrat. \n3. '-pass': La contrasenya utilitzada per xifrar el fitxer. \n",
                encryptSuccess: "S'ha configurat correctament l'encriptació de l'informe",
                encryptError: "Error en configurar l'encriptació de l'informe",
            },
            reportType: {
                BALLOT_RECEIPT: "Rebut de la Papereta",
                ELECTORAL_RESULTS: "Resultats Electorals",
                MANUAL_VERIFICATION: "Verificació Manual",
                PARTICIPATION_REPORT: "Informe de Participació",
                STATISTICAL_REPORT: "Informe Estadístic",
                OVCS_EVENTS: "Seguiment del Vot a l'Estranger - Esdeveniments OVCS",
                AUDIT_LOGS: "Registres d'Auditoria",
                ACTIVITY_LOG: "Registres d'Activitat",
                STATUS: "Estat",
                OVCS_INFORMATION: "Informació de l'OVCS",
                OVERSEAS_VOTERS: "Llista de Votants a l'Estranger",
                OV_USERS_WHO_VOTED: "Llista de Votants a l'Estranger que han Votat",
                OV_WITH_VOTING_STATUS: "Llista de Votants a l'Estranger amb Estat de Votació",
                OVCS_STATISTICS: "Seguiment del Vot a l'Estranger - Estadístiques de l'OVCS",
                PRE_ENROLLED_OV_BUT_DISAPPROVED: "Llista de Votants a l'Estranger Preinscrits però Desaprovats",
                PRE_ENROLLED_OV_SUBJECT_TO_MANUAL_VALIDATION: "Llista de Votants a l'Estranger Preinscrits però Sotmesos a Validació Manual",
            },
            reportEncryptionPolicy: {
                title: "Política de xifrat",
                UNENCRYPTED: "Sense xifrar",
                CONFIGURED_PASSWORD: "Contrasenya configurada",
            },
            empty: {
                header: "Encara no hi ha informes.",
                body: "Vols crear-ne un?",
                button: "Crear informe",
            },
            create: {
                title: "Crear informe",
                subtitle: "Crear una nova configuració d'informe.",
            },
            edit: {
                title: "Editar informe",
                subtitle: "Editar la configuració de l'informe.",
                delete: "Estàs segur que vols eliminar aquest informe?",
            },
            fields: {
                electionId: "Elecció",
                template: "Plantilla",
                reportType: "Tipus d'informe",
                repeatable: "Repetible",
                cronExpression: "Expressió Cron",
                emailRecipients: "Destinataris de correu electrònic",
                emailRecipientsPlaceholder: "Escriviu el correu electrònic i premeu Enter",
            },
            delete: {
                body: "Estàs segur que vols eliminar aquest informe?",
            },
            actions: {
                generate: "Generar",
                delete: "Eliminar",
                edit: "Editar",
                preview: "Previsualitzar",
            },
        },
        googleMeet: {
            title: "Generar Enllaç de Google Meet",
            generateButton: "Google Meet",
            meetingTitle: "Títol de la Reunió",
            description: "Descripció (Opcional)",
            startDate: "Data d'Inici",
            startTime: "Hora d'Inici",
            duration: "Durada (minuts)",
            attendeeEmails: "Emails dels Participants",
            attendeeEmailHelp: "Emails separats per comes per als participants de la reunió",
            note: "Nota: Això crearà un esdeveniment de calendari al teu Google Calendar amb un enllaç de Google Meet. Necessitaràs iniciar sessió al teu compte de Google.",
            success: "Enllaç de Google Meet Generat Correctament!",
            copy: "Copiar al porta-retalls",
            copied: "Enllaç copiat al porta-retalls!",
            instructions: "Comparteix aquest enllaç amb els participants per unir-se a la reunió. L'esdeveniment de calendari s'ha afegit al teu Google Calendar.",
            generating: "Generant...",
            generate: "Generar Enllaç de Meet",
        },
        common: {
            export: "L'exportació pot ser un procés llarg. Estàs segur que vols exportar?",
            resources: {
                electionEvent: "Esdeveniment Electoral",
                election: "Elecció",
                contest: "Pregunta",
                candidate: "Candidat",
                noResult: {
                    askCreate: "Vols crear-ne una?",
                },
            },
            label: {
                add: "Afegir",
                actions: "Accions",
                create: "Crear",
                delete: "Esborrar",
                archive: "Arxivar",
                unarchive: "Desarxivar",
                cancel: "Cancel·lar",
                edit: "Editar",
                yes: "Sí",
                no: "No",
                save: "Guardar",
                close: "Tancar",
                back: "Enrere",
                next: "Següent",
                warning: "Avis",
                json: "Vista prèvia",
                noResult: "Sense resultats",
                import: "Importar",
                export: "Exportar",
                loadingData: "Carregant dades...",
                exportFormat: "Exporta en format {{format}} - Resultats de '{{item}}'",
                allResults: "de l'esdeveniment electoral",
                globalAreaResults: "de totes les àrees",
                title: "Títol",
                subtitle: "Subtítol",
                kind: "Tipus d'arxiu",
                filter: "Filtres Personalizats",
                approve: "Aprovar",
                continue: "Continuar",
                logout: "Sortir",
                selectTenant: "Seleccionar Llogater",
                processing: "Processant...",
                tenantName: "Nom del Llogater",
            },
            language: {
                es: "Espanyol",
                en: "Anglès",
                fr: "Francès",
                cat: "Valencià",
                tl: "Tagal",
                gl: "Galego",
                nl: "Holandés",
                eu: "Euskera",
            },
            channel: {
                online: "En línia",
                kiosk: "Quiosc",
                early_voting: "Votació anticipada",
                telephone: "Votació telefònica",
                other: "Altres",
            },
            message: {
                delete: "Estàs segur que vols esborrar aquest element?",
                continueOrLogout: "Vols continuar conectat o sortir?",
            },
        },
        createResource: {
            electionEvent: "Crear un Esdeveniment Electoral",
            election: "Crear una Elecció",
            contest: "Crear una Pregunta",
            candidate: "Crear un Candidat",
            slate: "Crea una Candidatura",
        },
        importResource: {
            electionEvent: "Importar un Esdeveniment Electoral",
            election: "Importar una Elecció",
            contest: "Importar una Pregunta",
            candidate: "Importar un Candidat",
            ImportHashMismatch: "Els hash no coincideixen. Ha fallat la comprovació d'integritat.",
        },
        sideMenu: {
            electionEvents: "Processos Electorals",
            search: "Cercar",
            usersAndRoles: "Usuaris i Rols",
            logs: "Bitàcora",
            settings: "Configuració",
            help: "Ajuda",
            templates: "Plantilles",
            active: "Actius",
            archived: "Arxivats",
            addResource: {
                electionEvent: "Crear un Esdeveniment Electoral",
                election: "Crear una Elecció",
                contest: "Crear una Pregunta",
                candidate: "Crear un Candidat",
            },
            menuActions: {
                archive: {
                    electionEvent: "Arxivar aquest Esdeveniment Electoral",
                },
                unarchive: {
                    electionEvent: "Desarxivar aquest Esdeveniment Electoral",
                    election: "Desarxivar aquesta Elecció",
                    contest: "Desarxivar aquesta Pregunta",
                    candidate: "Desarxivar aquest Candidat",
                },
                remove: {
                    electionEvent: "Eliminar aquest Esdeveniment Electoral",
                    election: "Eliminar aquesta Elecció",
                    contest: "Eliminar aquesta Pregunta",
                    candidate: "Eliminar aquest Candidat",
                    slate: "Elimina aquesta Candidatura",
                },
                messages: {
                    confirm: {
                        archive: "Estàs segur de que vols arxivar aquest element?",
                        unarchive: "Estàs segur de que vols desarxivar aquest element?",
                        delete: "Estàs segur de que vols eliminar aquest element?",
                    },
                    notification: {
                        success: {
                            archive: "L'element ha estat arxivat",
                            unarchive: "L'element ha estat desarxivat",
                            delete: "L'element ha estat eliminat",
                            reloading: "Espera. La pàgina serà recarregada en alguns moments",
                        },
                        error: {
                            archive: "Error intentant arxivar aquest element",
                            unarchive: "Error intentant desarxivar aquest element",
                            delete: "Error intentant eliminar aquest element",
                        },
                    },
                },
            },
        },
        candidateScreen: {
            common: {
                subtitle: "Configuració de candidats.",
            },
            edit: {
                externalId: "ID extern",
                general: "General",
                type: "Tipus",
                image: "Imatge",
                isDisabled: "Deshabilitat",
                isExplicitInvalid: "Vot Invàlid",
                isExplicitBlank: "Vot en Blanc",
                isCategoryList: "Llista",
                isWriteIn: "Vot per escrit",
            },
            field: {
                name: "Nom",
                alias: "Àlies",
                description: "Descripció",
            },
            options: {
                "candidate": "Candidat",
                "option": "Opció",
                "write-in": "Vot per escrit",
                "open-list": "Llista oberta",
                "closed-list": "Llista tancada",
                "semi-open-list": "Llista semioberta",
                "invalid-vote": "Vot Invàlid",
                "blank-vote": "Vot en blanc",
            },
            invalidVotePosition: {
                label: "Posició del Vot Invàlid",
                null: "Cap (Per defecte)",
                top: "Superior",
                bottom: "Inferior",
            },
            error: {},
            createCandidateSuccess: "Candidat creat",
            createCandidateError: "Error creant candidat",
        },
        slateScreen: {
            common: {
                subtitle: "Configuració de la candidatura.",
                newSlate: "Nova candidatura",
                notFound: "Aquesta candidatura no existeix.",
            },
            tabs: {
                data: "Dades",
            },
            edit: {
                general: "General",
                members: "Membres",
            },
            field: {
                name: "Nom",
                alias: "Àlies",
                description: "Descripció",
                externalId: "ID extern",
            },
            members: {
                helper: "Assigna fins al nombre màxim de candidats de cada contesa. Deixa una contesa buida perquè aquesta candidatura no la cobreixi. Els candidats que no són a cap candidatura apareixen com a Independents en aquella contesa.",
                contest: "Contesa",
                candidate: "Candidat",
                noCandidate: "Sense candidat",
            },
            messages: {
                saved: "Candidatura desada",
                invalid: "No es pot desar la candidatura. Corregeix els problemes indicats a sota.",
                error: "No s'ha pogut desar la candidatura.",
                unreadable: "No es pot llegir la configuració de candidatures de l'elecció.",
            },
        },
        contestScreen: {
            common: {
                subtitle: "Configuració de pregunta.",
            },
            edit: {
                externalId: "ID extern",
                general: "General",
                type: "Tipus",
                image: "Imatge",
                system: "Sistema de votació de paperetes",
                design: "Disseny de la papereta",
                reorder: "Reordenar candidats",
                policies: "Polítiques",
            },
            field: {
                name: "Nom",
                alias: "Àlies",
                description: "Descripció",
            },
            options: {
                "non-preferential": "Sense Preferència",
                "plurality-at-large": "Majoria Plural",
                "instant-runoff": "Segona Volta Instantània",
                "random": "Aleatòries",
                "external-procedure": "Procediment extern",
                "custom": "Personalitzat",
                "alphabetical": "Alfabètic",
            },
            tieBreakingPolicy: {
                label: "Política de desempat",
            },
            auditButtonConfig: {
                "label": "Opció de visualització del botó d'auditoria",
                "show": "Mostrar",
                "not-show": "No mostrar",
                "show-in-help": "Mostra al diàleg d'ajuda",
            },
            underVotePolicy: {
                "label": "Política de Votació Inferior",
                "allowed": "Permès",
                "warn-only-in-review": "Advertir en Revisió",
                "warn": "Advertir",
                "warn-and-alert": "Advertir i Alertar",
                "warn-and-confirm-in-review": "Advertir i Confirmar en Revisió",
            },
            invalidVotePolicy: {
                "label": "Política de vot invàlid",
                "allowed": "Permesa",
                "warn": "Advertència",
                "warn-invalid-implicit-and-explicit": "Advertir Invàlids Implícits i Explícits",
                "not-allowed": "No Permesa",
                "allowed-with-exclusive-explicit": "Permesa amb Vot Invàlid Exclusiu",
            },
            candidatesIconCheckboxPolicy: {
                "label": "Forma de la icona de la casella de verificació dels candidats",
                "square-checkbox": "Caixa de verificació quadrada",
                "round-checkbox": "Caixa de verificació rodona",
            },
            checkableListPolicy: {
                "allow-selecting-candidates-and-lists": "Candidats I Llistes",
                "allow-selecting-candidates": "Només Candidats",
                "allow-selecting-lists": "Només Llistes",
                "disabled": "Deshabilitat",
            },
            collapsibleListsPolicy: {
                "label": "Llistes plegables",
                "disabled": "Desactivat",
                "enabled-expanded": "Activat (comença expandit)",
                "enabled-collapsed": "Activat (comença contret)",
            },
            blankVotePolicy: {
                "label": "Política de vot en blanc",
                "allowed": "Permès",
                "warn-only-in-review": "Advertir en Revisió",
                "warn": "Advertir",
                "not-allowed": "No permès",
            },
            overVotePolicy: {
                "label": "Política de vot excessiva",
                "allowed": "Permès",
                "allowed-with-msg": "Permès amb missatge d'avís",
                "allowed-with-msg-and-alert": "Permès amb missatge d'avís i alerta",
                "not-allowed-with-msg-and-alert": "No es permet amb missatge d'avís i alerta",
                "not-allowed-with-msg-and-disable": "No es permet amb missatge d'avís i desactiva més seleccions",
            },
            duplicatedRankPolicy: {
                "label": "Vot invàlid - Política de rang duplicat",
                "allowed-warn-and-dialog": "Mostrar advertiment i diàleg (el votant pot continuar)",
                "not-allowed-warn-and-dialog": "Mostrar advertiment i diàleg (el votant no pot continuar)",
            },
            preferenceGapsPolicy: {
                "label": "Vot invàlid - Política de rangs omesos",
                "allowed-warn-and-dialog": "Mostrar advertiment i diàleg (el votant pot continuar)",
                "not-allowed-warn-and-dialog": "Mostrar advertiment i diàleg (el votant no pot continuar)",
            },
            paginationPolicy: {
                label: "Nom de la pàgina",
            },
            isAcclaimed: {
                label: "Resolt per aclamació",
                helperText: "Els votants veuen aquesta votació però no poden seleccionar res, no es registra res i totes les candidatures es declaren guanyadores amb zero vots. Configureu-ho abans de publicar les paperetes: canviar-ho després invalida les paperetes ja emeses.",
            },
            allowWriteins: {
                label: "Permetre candidatures manuals",
            },
            maxVotes: {
                helperText: "Nombre màxim de candidats que un votant pot seleccionar (votació no preferencial).",
                helperTextPreferential: "Posició de rang més alta disponible per als votants (p.ex. '5' significa posicions 1–5). Ha de ser almenys igual al nombre de candidats a ordenar (votació preferencial).",
            },
            error: {},
            createContestSuccess: "Pregunta creada",
            createContestError: "Error en crear la pregunta",
        },
        keysGeneration: {
            configureStep: {
                create: "Crear Cerimònia de Claus",
                name: "Nom de la Cerimònia de Claus",
                allElections: "Totes les Eleccions",
                title: "Crear Cerimònia de Claus de l'Esdeveniment Electoral",
                subtitle: "En aquesta cerimònia cada autoritat generarà i descarregarà la seva part de les claus privades per a l'Esdeveniment Electoral. Per continuar, trieu les autoritats que participaran en la cerimònia i el llindar, que és el nombre mínim d'autoritats necessaris per comptar.",
                trusteeList: "Autoritats",
                threshold: "Llindar",
                errorMinTrustees_one: "Has seleccionat només {{selected}} autoritat, però has de seleccionar almenys {{threshold}}.",
                errorMinTrustees_many: "Has seleccionat només {{selected}} autoritats, però has de seleccionar almenys {{threshold}}.",
                errorMinTrustees_other: "Has seleccionat només {{selected}} autoritats, però has de seleccionar almenys {{threshold}}.",
                errorThreshold: "Has seleccionat un llindar de {{selected}} però ha d'estar entre {{min}} i {{max}}.",
                errorCreatingCeremony: "Error creant Cerimònia de Claus: {{error}}",
                createCeremonySuccess: "Cerimònia de Claus creada",
                confirmdDialog: {
                    ok: "Sí, Crear Cerimònia de Claus",
                    cancel: "Cancel·lar",
                    title: "Estàs segur de que vols Crear una Cerimònia de Claus?",
                    automaticCeremonyTitle: "Estàs segur que vols crear una cerimònia de claus automàtica?",
                    description: "Estàs a punt de Crear una Cerimònia de Claus. Aquesta acció notificarà a les Autoritats per participar en la creació i distribució de les Claus de l'Esdeveniment Electoral.",
                    automaticCeremonyDescription: "Estàs a punt de crear una cerimònia de claus automàtica. Això no notificarà als fideïcomissaris que hi participin.",
                },
                filterTrustees: "Filtrar Autoritats",
                errorPermisionLabels: "No es pot crear la cerimònia de claus: falta almenys una etiqueta de permís.",
                automaticCeremonyToggle: "Cerimònia automàtica",
            },
            ceremonyStep: {
                cancel: "Cancel·lar Cerimònia de Claus",
                progressHeader: "Progrés de Cerimònia de Claus",
                description: "Aquesta pantalla mostra el progrés i els registres de la Cerimònia de Claus de l'Esdeveniment Electoral. En la Cerimònia de Claus, cada autoritat generarà i descarregarà el seu fragment de la clau privada per a l'Esdeveniment Electoral.",
                executionStatus: "Estat: {{status}}",
                confirmdDialog: {
                    ok: "Sí, Cancel·lar Creació de Cerimònia de Claus",
                    cancel: "Tornar a la Cerimònia de Claus",
                    title: "Estàs segur de que vols Cancel·lar la Cerimònia de Claus?",
                    description: "Estàs a punt de Cancel·lar la Cerimònia de Claus. Després de realitzar aquesta acció, per tenir una Cerimònia de Claus exitosa hauràs de Crear una nova.",
                },
                header: {
                    trusteeName: "Nom d'Autoritat",
                    fragment: "Fragment de Clau Generat",
                    downloaded: "Fragment Privat de Clau Descarregat",
                    checked: "Fragment Privat de Clau Comprovat",
                },
                logsHeader: {
                    title: "Registres",
                    date: "Data",
                    entry: "Entrada",
                },
                emptyLogs: "Sense logs encara.",
            },
            startStep: {
                title: "Cerimònia de Claus d'Autoritat",
                subtitle: "Estàs a punt de participar en la Cerimònia de Claus com l'Autoritat (<strong>{{name}}</strong>). Això implica els següents passos:",
                one: "<strong>Descarregar</strong> la teva Clau Privada Encriptada.",
                two: "Crear múltiples <strong>Còpies de seguretat</strong> de la teva Clau Privada Encriptada.",
                three: "<strong>Verificar</strong> que les còpies de seguretat funcionen correctament.",
            },
            downloadStep: {
                title: "Descarregar Clau Privada Encriptada",
                subtitle: "Per continuar, si us plau descarrega i guarda la teva Clau Privada Encriptada en almenys dos dispositius diferents:",
                downloadButton: "Descarregar la teva Clau Privada Encriptada",
                downloaded: "Clau Privada Encriptada descarregada correctament.",
                errorEmptyKey: "Error de descàrrega, fitxer buit",
                unexpectedError: "No s'ha pogut descarregar la clau privada. Torna-ho a provar.",
                alreadyVerified: "La teva clau privada ja s'havia descarregat i verificat.",
                unavailable: "La descàrrega de la clau privada ja no està disponible perquè la cerimònia ha avançat.",
                confirmdDialog: {
                    ok: "Confirmar còpies de seguretat i Continuar",
                    cancel: "Tornar",
                    title: "Còpia de seguretat de la teva Clau Privada Encriptada",
                    description: "Si us plau, realitza una còpia de seguretat de la teva Clau Privada Encriptada en almenys dues ubicacions segures diferents i després confirma-ho a continuació:",
                    firstCopy: "Primera còpia de seguretat realitzada",
                    secondCopy: "Segona còpia de seguretat realitzada",
                    confirmError: "Creeu les còpies de seguretat necessàries i marqueu les caselles de confirmació per continuar",
                },
            },
            checkStep: {
                title: "Verifica les teves Còpies de Seguretat de la teva Clau Privada Encriptada",
                verifyButton: "Verifica la clau",
                subtitle: "Puja la Còpia de Seguretat de la teva Clau Privada Encriptada per verificar que sigui correcta. Pots intentar-ho tantes vegades com sigui necessari, des de les teves diferents còpies de seguretat:",
                errorUploading: "Còpia de Seguretat de la Clau Encriptada Privada invàlida, si us plau intenta-ho de nou",
                errorEmptyFile: "Fitxer buit o no trobat",
                verified: "Còpia de seguretat verificada correctament.",
                alreadyRestored: "La teva clau ja s'havia restaurat.",
            },
        },
        miruExport: {
            create: {
                success: "Paquet de Transmissió Creat",
                error: "Error en crear el Paquet de Transmissió",
            },
            send: {
                success: "Paquet de Transmissió Enviat",
                error: "Error en enviar el Paquet de Transmissió",
            },
        },
        tally: {
            errorUploadingSignature: "S'ha produït un error en carregar la signatura",
            downloadTransmissionPackage: "Descarregar paquet",
            resultsPublication: {
                sectionTitle: "Publicar al lloc web de resultats",
                policyTitle: "Lloc web de resultats",
                policyAccess: "Accés al lloc web de resultats",
                policyVisibility: "Visibilitat del lloc web de resultats",
                enabled: "Activat",
                disabled: "Desactivat",
                fullEvent: "Esdeveniment complet",
                areaBased: "Per àrea",
                publishStarted: "Publicació de resultats iniciada",
                publishError: "No s'ha pogut iniciar la publicació de resultats",
                revoked: "Publicació de resultats revocada",
                revokeError: "No s'ha pogut revocar la publicació de resultats",
                waitingForTally: "Els resultats es poden publicar quan aquest recompte hagi finalitzat.",
                writePermissionRequired: "Necessiteu el permís publish-results-write per publicar o revocar resultats.",
                readPermissionRequired: "Necessiteu el permís publish-results-read per veure l'historial de publicacions.",
                disabledPolicy: "La publicació al lloc web de resultats està desactivada per a aquest esdeveniment electoral. Activeu-la a les dades de l'esdeveniment electoral abans de publicar resultats.",
                loadingElectionContext: "La publicació de resultats està carregant el context de l'elecció.",
                route: "Ruta",
                eventResults: "Resultats de l'esdeveniment",
                electionResults: "Resultats de l'elecció",
                election: "Elecció",
                access: "Accés",
                publicAccess: "Accés públic",
                authenticatedAccess: "Accés autenticat",
                visibility: "Visibilitat",
                fullPublishedScope: "Àmbit publicat complet",
                personalVisibility: "Visibilitat personal",
                contests: "Preguntes",
                noTalliedContests: "No hi ha preguntes escrutades disponibles.",
                publishSelectedContests: "Publicar les preguntes seleccionades",
                selectedContestCount_one: "{{count}} pregunta seleccionada",
                selectedContestCount_many: "{{count}} preguntes seleccionades",
                selectedContestCount_other: "{{count}} preguntes seleccionades",
                history: "Historial de publicacions",
                version: "Versió",
                status: "Estat",
                published: "Publicat",
                revokedAt: "Revocat",
                actions: "Accions",
                open: "Obrir",
                revoke: "Revocar",
                noPublications: "Encara no hi ha publicacions.",
                confirmTitle: "Voleu iniciar la publicació al lloc web de resultats?",
                confirmDescription: "Això crearà una nova publicació a partir del recompte actual. Els resultats que veuen els votants es mantindran actius fins que aquesta tasca de publicació acabi correctament.",
                close: "Tancar",
            },
            transmissionPackage: {
                title: "Paquet de Transmissió per a l'Àrea '{{name}}' y Elección '{{eventName}}'",
                description: "Et permet exportar un Paquet de Transmissió als Servidors de Destinació o descarregar-lo.",
                actions: {
                    sign: {
                        title: "Regenerar",
                        dialog: {
                            title: "Vols signar el paquet de transmissió?",
                            description: "Si us plau, confirma que vols regenerar el paquet de transmissió per a l'àrea `{{name}}`",
                            confirm: "Signar el paquet de transmissió",
                            cancel: "Tancar",
                            input: {
                                placeholder: "Introdueix la teva contrasenya",
                            },
                        },
                    },
                    send: {
                        title: "Enviar",
                        dialog: {
                            title: "Vols enviar el Paquet de Transmissió?",
                            description: "Si us plau, confirma que vols enviar el Paquet de Transmissió per a l'Àrea '{{name}}' als Servidors de Destinació.",
                            confirm: "Enviar Paquet de Transmissió",
                            cancel: "Tancar",
                        },
                    },
                    regenerate: {
                        title: "Regenerar",
                        dialog: {
                            title: "Vol regenerar el paquet de transmissió?",
                            description: "Si us plau, confirmi que vol regenerar el paquet de transmissió per a l'àrea `{{name}}`",
                            confirm: "Regenerar paquet de transmissió",
                            cancel: "Tancar",
                        },
                    },
                    download: {
                        title: "Descarregar",
                        emlTitle: "Descarregar EML {{date}}",
                        transmissionPackageTitle: "Descarregar el Paquet de Transmissió {{date}}",
                        transmissionReportTitle: "Descarrega l'informe de transmissió",
                        dialog: {
                            title: "Vols descarregar el Paquet de Transmissió?",
                            description: "Si us plau, confirma que vols descarregar el Paquet de Transmissió per a l'Àrea '{{name}}.'",
                            confirm: "Descarregar Paquet de Transmissió",
                            cancel: "Tancar",
                        },
                    },
                },
                destinationServers: {
                    title: "Servidors de Destinació",
                    description: "La taula a continuació mostra l'estat d'enviament de cadascun dels Servidors de Destinació.",
                    status: "Enviat a {{signed}} de {{total}}",
                    table: {
                        serverName: "Nom del Servidor",
                        sendStatus: "Estat d'Enviament",
                    },
                },
                signatures: {
                    title: "Signatures SBEI",
                    description: "Els SBEIs poden signar el Paquet de Transmissió. La taula a continuació mostra l'estat de signatura de cada un dels membres del SBEI.",
                    table: {
                        trusteeName: "Nom del Fiduciari",
                        signed: "Ha Signat",
                    },
                    status: "{{signed}} de {{total}} Han Signat, mínim {{minimum}}",
                },
            },
            sendToTransmissionPackageServers: "Enviar paquet de transmissió per a l'àrea '{{name}}'",
            uploadTransmissionPackage: "Carregar",
            uploadTransmissionPackageDesc: "Carrega la teva signatura per signar el paquet de Resultats Electorals. Aquesta operació és opcional.",
            exportElectionArea: "Envia paquet de transmissió per a l'àrea '{{name}}'",
            generateReport: "Genera {{name}}",
            templateTitle: "Plantilla de Resultats",
            initializationTitle: "Eleccions per a l'informe d'inicialització",
            templateSubTitle: "Opcionalment sobreescriure la plantilla de resultats.",
            keysCeremonyTitle: "Cerimònia de Claus",
            keysCeremonySubTitle: "Selecciona la Cerimònia de Claus per a aquest recompte",
            ceremonyTitle: "Eleccions per al Recompte",
            ceremonySubTitle: "Seleccioneu les eleccions per al recompte",
            tallyTitle: "Progrés del Recompte d'Eleccions",
            logsTitle: "Registres",
            resultsTitle: "Resultats & Participació",
            generalInfoTitle: "Informació General",
            trusteeTallyTitle: "Trustee",
            trusteeTallySubTitle: "Estat d'importació del fragment de clau",
            eligibility: {
                selectElection: "Selecciona almenys una elecció.",
                publishElection: "Publica cada elecció seleccionada abans de crear-ne el recompte.",
                tallyDisallowed: "El recompte està deshabilitat per a una elecció seleccionada.",
                endVoting: "Finalitza la votació de cada elecció seleccionada i atura els canals actius abans de crear el recompte.",
            },
            createTallySuccess: "Recompte creat",
            createTallyError: "Error creant recompte",
            startTallySuccess: "Recompte iniciat",
            startTallyError: "Error iniciant recompte",
            startTallyCeremonySuccess: "Iniciada la cerimònia del recompte",
            startTallyCeremonyError: "No s'ha pogut iniciar la cerimònia del recompte",
            cancelTallyCeremonySuccess: "Cancel·lada la cerimònia del recompte",
            cancelTallyCeremonyError: "No s'ha pogut cancel·lar la cerimònia del recompte",
            recountTallyCeremony: "Repetir el recompte",
            recountTallyCeremonyMessage: "Això generarà un nou esdeveniment de resultats per a la sessió de recompte completada.",
            recountTallyCeremonyStarting: "S'està iniciant el recompte...",
            recountTallyCeremonySuccess: "Recompte iniciat",
            recountTallyCeremonyError: "No s'ha pogut iniciar el recompte",
            recountTallyCeremonyOk: "Repetir el recompte",
            trusteeTitle: "Proces del trustee",
            trusteeSubTitle: "Si us plau, importeu el vostre fragment de clau",
            invited: "Has estat convidat a participar en una cerimònia de recompte. Si us plau, ",
            click: "feu clic en l'acció de recompte",
            participate: "per participar.",
            breadcrumbSteps: {
                start: "Inici",
                finish: "Final",
                tally: "Recompte",
                results: "Resultats",
                ceremony: "Cerimònia",
            },
            common: {
                title: "Recompte",
                subTitle: "Configuració del Recompte.",
                cancel: "Enrere",
                next: "Següent",
                date: "Data de Recompte",
                global: "Global",
                noTrustees: "Encara no hi ha trustees",
                imported: " trustees han importat el seu fragment de clau",
                needed: " trustees necessaris per al recompte",
                start: "Iniciar Recompte",
                ceremony: "Iniciar Cerimònia de Recompte",
                initialization: "Inicia l'informe d'inicialització",
                results: "Resultats",
                dialog: {
                    ok: "D'acord",
                    okTally: "Iniciar recompte",
                    okCancel: "Cancel·lar recompte",
                    cancel: "Tancar",
                    title: "Estàs segur de que vols iniciar una cerimònia?",
                    tallyTitle: "Estàs segur de que vols iniciar el recompte?",
                    cancelTitle: "Estàs segur de que vols cancel·lar el recompte?",
                    message: "Estàs a punt d'iniciar una cerimònia de recompte. Aquesta acció notificarà als trustees per importar els seus fragments de clau.",
                    cancelMessage: "Estàs a punt de cancel·lar la cerimònia de recompte. Aquesta acció no es pot desfer.",
                    ceremony: "Tots els trustees requerits han verificat els seus fragments de clau. Tot està a punt per començar a rebre resultats. Voleu iniciar el Recompte?",
                    startAutomatedTallyMessage: "Seleccioneu 'Start Tally' per executar el procés de recompte i mostrar els resultats, o 'Close' per cancel·lar.",
                },
            },
            table: {
                elections: "Eleccions",
                selected: "Seleccionades",
                status: "Estat",
                progress: "Progrés",
                method: "Mètode de Recompte",
                elegible: "Votants Elegibles",
                number: "Número de Vots",
                total: "Total",
                turnout: "%",
                candidates: "Resultats de Candidats",
                options: "Opcions",
                global: "Resum de participació",
                elegible_census: "Cens de votants elegibles",
                cast_votes: "Número de Vots",
                cast_votes_percent: "Percentatges de Vots",
                total_votes: "Total de votants",
                total_votes_percent: "Participació",
                total_votes_counted: "Total de Vots Comptats",
                total_auditable_votes: "Total de Vots Auditables",
                total_valid_votes: "Total de vots vàlids",
                total_valid_votes_percent: "Percentatge de vots vàlids",
                total_invalid_votes: "Total de vots invàlids",
                total_invalid_votes_percent: "Percentatge de vots invàlids",
                explicit_invalid_votes: "Vots explícitament invàlids",
                explicit_invalid_votes_percent: "Percentatge de vots explícitament invàlids",
                implicit_invalid_votes: "Vots implícitament invàlids",
                implicit_invalid_votes_percent: "Percentatge de vots implícitament invàlids",
                blank_votes: "Vots en blanc",
                explicit_blank_votes: "Vots en blanc explícits",
                implicit_blank_votes: "Vots en blanc implícits",
                blank_votes_percent: "Percentatge de vots en blanc",
                number_of_votes: "Número de vots",
                winning_position: "Posició guanyadora",
                weight: "Pes",
                preferential: {
                    candidate: "Candidat",
                    winner: "Guanyador",
                    eliminated: "Eliminat",
                    round: "Ronda",
                },
                total_declined_to_vote: "Total de vots de renúncia",
                total_blank_ballots: "Total de Paperetes en Blanc",
                participation_by_channel: "Participació per canal",
                channel: "Canal",
                channel_online: "En línia",
                channel_kiosk: "Quiosc",
                channel_early_voting: "Votació anticipada",
                channel_telephone: "Telèfon",
                channel_paper: "Paper",
                channel_postal: "Postal",
                channel_in_person: "Presencial",
                acclamation_note: "Elegit per aclamació. Aquesta votació es va resoldre sense votació, per la qual cosa no es va registrar cap vot.",
            },
            pendingResolutions: {
                round: "Ronda {{round}}",
                tieResolutionRequired: "Cal resolució d'empat",
                tieResolved: "Empat resolt",
                globalArea: "Global",
                pendingResolutionsHeader: "Resolucions pendents",
                pendingResolutionStatus: "Resolució pendent",
                resolvedStatus: "Resolta",
                resolutionTitle: "Resolució",
                selectContest: "Seleccioneu un element a l'esquerra per veure els detalls",
                selectCandidateToAdvance: "Seleccioneu el candidat a avançar",
                undoResolution: "Desfer la resolució",
                applyResolutions: "Aplicar resolucions i recalcular",
                submitSuccess: "Resolucions enviades. El recompte s'està reprenent...",
                submitError: "Error en enviar les resolucions. Torneu-ho a intentar.",
                filter: "Filtra",
                save: "Desa",
                pendingApplyStatus: "Càlcul pendent",
                filterElection: "Elecció",
                filterContest: "Pregunta",
                filterArea: "Àrea",
                filterStatusLabel: "Estat",
                clearFilters: "Esborrar filtres",
                candidateWithVotes: "{{name}} ({{votes}} vots)",
                candidateWithVotesAndPercent: "{{name}} ({{votes}} vots, {{percent}}%)",
                tieInfoTitle: "Recompte pausat per empat sense resoldre (Ronda {{round}})",
                tieInfoBody: "Candidats empatats ({{votes}} vots, {{percent}}%): {{candidates}}. Cal un desempat manual per continuar el recompte.",
                tallyResumedTitle: "Recompte reprès després d'aplicar la resolució",
                tallyResumedBody: "L'empat va ser resolt el {{date}} per {{user}}",
            },
            chart: {
                votesForCandidates: "Vots per Candidats",
                blankVotes: "Vots en Blanc",
                invalidVotes: "Vots Invàlids",
                totalVoters: "Total de Votants",
                nonVoters: "No Votants",
            },
            exportAllAreas: "Exporta els resultats de totes les àrees en format {{format}} per a '{{item}}'",
        },
        publish: {
            preview: {
                publicationAreas: "Selecciona l'àrea per a la vista prèvia",
                action: "Vista prèvia",
                copy: "Copia l'enllaç",
                copy_success: "Copia correctament l'enllaç de previsualització",
                copy_error: "No s'ha pogut copiar l'enllaç de previsualització",
                success: "Previsualització oberta amb èxit",
            },
            header: {
                change: "Canvis a Publicar",
                viewChange: "Veure Publicació",
                history: "Històric de Canvis",
            },
            action: {
                generateInitializationReport: "Genera l'Informe d'Inicialització",
                startVotingPeriod: "Començar el període de votació",
                startKioskVoting: "Començar Votació al Quiosc",
                startOnlineVoting: "Començar Votació en Línia",
                startEarlyVoting: "Començar Votació Anticipada",
                startTelephoneVoting: "Començar Votació Telefònica",
                stopVotingPeriod: "Detenir el període de votació",
                stopOnlineVoting: "Detenir la Votació en Línia",
                stopEarlyVoting: "Detenir la Votació Anticipada",
                stopTelephoneVoting: "Detenir la Votació Telefònica",
                stopKioskVotingPeriod: "Aturar la Votació al Quiosc",
                pauseVotingPeriod: "Pausar el període de votació",
                pauseKioskVoting: "Pausar la Votació al Quiosc",
                pauseOnlineVoting: "Pausar la Votació en Línia",
                pauseEarlyVoting: "Pausar la Votació Anticipada",
                pauseTelephoneVoting: "Pausar la Votació Telefònica",
                generate: "Regenerar",
                publish: "Publicar Canvis",
                back: "Enrere",
            },
            empty: {
                header: "Encara no hi ha Publicació.",
                action: "Generar Publicació",
            },
            forbidden: {
                header: "No es pot publicar fins que s'hagi completat la cerimònia de claus.",
            },
            dialog: {
                title: "Confirmar Acció",
                info: "Has fet clic en una acció sensible, per la qual cosa necessitem que la confirmis per poder continuar.",
                initializationInfo: "Esteu a punt de generar l'informe d'inicialització. Esteu segur que voleu continuar?",
                startInfo: "Està a punt de començar el període de votació. Està segur que vol continuar?",
                stopInfo: "Està a punt de detenir el període de votació. Està segur que vol continuar?",
                kioskStopInfo: "Esteu a punt d'aturar el període de votació del quiosc. Esteu segur que voleu continuar?",
                pauseInfo: "Està a punt de pausar el període de votació. Està segur que vol continuar?",
                publishInfo: "Esteu a punt de generar una publicació. Segur que voleu continuar?",
                ok: "Confirmar",
                ko: "Cancel·lar",
                error: "Error carregant les paperetes publicades",
                error_publish: "Error publicant la papereta",
                error_capacity: "Error en generar l'estil de papereta: {{message}}",
                error_status: "Error canviant l'estat de la publicació",
                error_preview: "S'ha produït un error en visualitzar la publicació",
                diff: "Renderitzar tots els canvis podria fer que la pàgina no respongui. Esteu segur que voleu continuar?",
                confirmation: "L'acció que esteu a punt de realitzar és sensible i requereix confirmació. Introduïu la vostra contrasenya per continuar amb {{action}}.",
            },
            label: {
                current: "Actual",
                previous: "Publicació Anterior",
                diff: "Canvis a publicar",
                publication: "Publicació",
            },
            notifications: {
                generated: "Papereta generada",
                published: "Papereta publicada",
                change_status: "Votació canviada d'estat",
            },
        },
        emailEditor: {
            subject: "Assumpte de l'Email",
            tabs: {
                plaintext: "Cos de Text Pla",
                richtext: "Cos de Text Enriquit",
            },
        },
        sendCommunication: {
            send: "Enviar",
            title: "Enviar Notificació",
            subtitle: "Enviar una notificació a usuaris/votants.",
            sendButton: "Enviar Notificació",
            voters: "Audiència",
            schedule: "Calendari",
            nowInput: "Enviar ara",
            dateInput: "Data i hora de començament d'enviament",
            chooseDate: "Si us plau trieu una data",
            languages: "Idiomes",
            smsMessage: "Missatge SMS",
            errorSending: "Error enviant la notificació: {{error}}",
            successSending: "Notificació programada/enviada amb èxit",
            method: "Mètode de Plantilles",
            type: "Tipus de Comunicació",
            alias: "Àlies de la Plantilla",
            votersSelection: {
                ALL_USERS: "Tots",
                NOT_VOTED: "Els que no han votat",
                VOTED: "Els que ja han votat",
                SELECTED: "A {{total}} {{voters}} seleccionats",
            },
            path: {
                users: "usuaris",
                voters: "votants",
            },
            methodTitle: "Mètode de Comunicació",
            communicationMethod: {
                EMAIL: "Email",
                SMS: "SMS",
            },
            communicationType: {
                CREDENTIALS: "Credencials",
                BALLOT_RECEIPT: "Comprovant de Votació",
            },
            email: {
                subject: "Assumpte",
            },
        },
        tallysheet: {
            title: "Urnes",
            subtitle: "Urnes digitalitzades per canal",
            createTallySuccess: "Acta de Recompte creada",
            createTallyError: "Error creant Acta de Recompte",
            createTallyErrorSameKindExists: "El full de recompte ja existeix per a aquesta pregunta amb el mateix canal i àrea",
            allFieldsRequired: "Tots els camps són obligatoris",
            header: {
                change: "Canvis a Publicar",
                viewChange: "Veure Publicació",
                history: "Historial de Publicació",
            },
            action: {
                start: "Començar Elecció",
                stop: "Aturar Elecció",
                pause: "Pausar",
                generate: "Regenerar",
                publish: "Publicar Canvis",
                back: "Enrere",
            },
            inputError: {
                totalValidDoesNotMatch: "Els vots de candidats ({{candidateVotesSum}}) han d'estar entre {{lowerBound}} i {{upperBound}} segons les regles de votació d'aquesta pregunta ({{nonBlankValidVotes}} vots vàlids no en blanc × fins a {{maxMarks}} marques per papereta)",
                censusTooSmall: "El total de vots ({{totalVotes}}) no pot ser major que el cens ({{census}})",
                totalInvalidDoesNotMatch: "El total de vots invàlids ({{totalInvalid}}) ha de ser igual als vots invàlids implícits ({{implicitInvalid}}) més els vots invàlids explícits ({{explicitInvalid}})",
                totalVotesDoesNotMatch: "El total de vots ({{totalVotes}}) ha de ser igual al total de vots vàlids ({{totalValidVotes}}) més el total de vots invàlids ({{totalInvalid}})",
                unknownCountingAlgorithm: "L'algorisme de recompte d'aquesta pregunta ({{countingAlgorithm}}) no es reconeix, de manera que no es pot determinar el nombre permès de vots de candidats. Reviseu la configuració de la pregunta.",
                blankBallotsInconsistent: "Les Paperetes en Blanc han de tenir el mateix valor a tots els fulls de recompte d'aquesta urna",
                blankBallotsOutOfBounds: "El valor de Paperetes en Blanc està fora del rang que impliquen els recomptes de vots en blanc per pregunta d'aquesta urna",
            },
            label: {
                area: "Àrea",
                channel: "Canal",
                total_votes: "Vots Totals",
                total_valid_votes: "Vots Vàlids Totals",
                total_invalid: "Vots Invàlids Totals",
                explicit_invalid: "Vots Explícitament Invàlids",
                implicit_invalid: "Vots Implícitament Invàlids",
                total_blank_votes: "Vots en Blanc Totals",
                blank_ballots: "Paperetes en Blanc",
                census: "Cens",
            },
            common: {
                tallyCeremony: {
                    manage: "Gestionar la Cerimònia de Còmput",
                    view: "Veure la Cerimònia de Còmput",
                    cancel: "Cancel·lar la Cerimònia de Còmput",
                    addKey: "Afegir Clau de Còmput",
                },
                edit: "Editar",
                confirm: "Confirmar",
                back: "Enrere",
                next: "Següent",
                cancel: "Enrere",
                data: "Dades",
                title: "Acta de Recompte",
                subtitle: "Configuració de l'Acta de Recompte.",
                candidates: "Candidats",
                save: "Guardar",
                approve: "Aprovar",
                disapprove: "Desaprovar",
                show: "Mostrar",
                add: "Afegir",
                versions: "Versions",
                warningDisapprove: "Estàs segur de desaprovar aquest Full de Recompte?",
                warningApprove: "Estàs segur d'aprovar aquest Full de Recompte?",
            },
            empty: {
                header: "No hi ha Actes de Recompte.",
                action: "Generar Acta de Recompte",
                add: "Afegir",
            },
            breadcrumbSteps: {
                start: "Inici",
                edit: "Editar",
                confirm: "Confirmar",
                view: "Veure",
            },
            table: {
                area: "Àrea",
                contest: "Pregunta",
                approvedVersion: "Versió aprovada",
                latestVersion: "Última versió",
                labels: "Etiquetes",
                annotations: "Anotacions",
            },
            versionsTable: {
                title: "Versions de l'urna",
                version: "Versió",
                createdBy: "Creat per",
                reviewedBy: "Revisat per",
                createdAt: "Creat el",
                reviewedAt: "Revisat el",
                sourceImport: "Importació d'origen",
                importStatus: "Estat de la importació",
                openImport: "Obrir importació",
                sourceFile: "Fitxer d'origen",
            },
            message: {
                reviewError: "Error revisant l'Acta de Recompte",
                reviewSuccess: "Acta de Recompte revisada",
            },
        },
        application: {
            import: {
                title: "Importar Aplicacions",
                subtitle: "Importar dades d'aplicacions",
                paragraph: "Importa aplicacions utilitzant un fitxer de full de càlcul en format de valors separats per comes (CSV). Descarrega un fitxer CSV d'exemple aquí.",
                messages: {
                    success: "Aplicacions importades amb èxit",
                    error: "Error en importar les aplicacions",
                },
            },
            export: {
                title: "Exportar Aplicacions",
                subtitle: "Exportar dades d'aplicacions",
                button: "Exportar",
                paragraph: "Exporta aplicacions utilitzant un fitxer de full de càlcul en format de valors separats per comes (CSV).",
                messages: {
                    success: "Aplicacions exportades amb èxit",
                    error: "Error en exportar les aplicacions",
                },
            },
        },
        template: {
            noPermissions: "No tens permisos per accedir a les Plantilles.",
            title: "Plantilles",
            subtitle: "Llistat de plantilles",
            chooseMethods: "Trieu Mètodes",
            default: "Utilitzeu la plantilla predeterminada",
            empty: {
                title: "No hi ha plantilles",
                subtitle: "Vols crear-ne una de nova?",
            },
            action: {
                createOne: "Crear Plantilla",
            },
            create: {
                title: "Crear una Plantilla",
                success: "Plantilla creada",
                error: "Error creant plantilla",
            },
            update: {
                success: "Plantilla actualitzada",
                error: "Error actualitzant plantilla",
            },
            edit: {
                title: "Editar una Plantilla",
            },
            form: {
                smsMessage: "Missatge SMS",
                document: "Document",
                pdfOptions: "Opcions PDF",
                reportOptions: "Opcions Report",
                name: "Nom de la Plantilla",
                alias: "Àlies de la Plantilla",
                type: "Tipus",
                communicationMethod: "Mètode",
            },
            type: {
                CREDENTIALS: "Credencials",
                INITIALIZATION_REPORT: "Informe d'Inicialització",
                ELECTORAL_RESULTS: "Resultats Electorals",
                BALLOT_IMAGES: "Imatges de Butlleta",
                BALLOT_RECEIPT: "Rebut de Vot",
                ACTIVITY_LOGS: "Registres d'Activitats",
                MANUAL_VERIFICATION: "Verificació Manual",
                PARTICIPATION_REPORT: "Informe de Participació",
            },
            method: {
                email: "Email",
                sms: "SMS",
                document: "Document",
            },
            import: {
                title: "Importar Plantilles",
                subtitle: "Importar dades de plantilles",
                paragraph: "Importa plantilles utilitzant un fitxer de full de càlcul en format de valors separats per comes (CSV). Descarrega un fitxer CSV d'exemple aquí.",
            },
        },
        materials: {
            createMaterialSuccess: "Material de suport creat",
            createMaterialError: "Error creant material de suport",
            updateMaterialSuccess: "Material de suport actualitzat",
            updateMaterialError: "Error actualitzant material de suport",
            common: {
                title: "Materials de Suport",
                subtitle: "Introduir dades del material de suport.",
            },
            error: {
                title: "El títol és obligatori",
                document: "El document és obligatori",
            },
            fields: {
                isHidden: "Ocult",
                publicUrl: "Enllaç públic",
            },
            empty: {
                header: "Encara no hi ha material de suport",
                action: "Genera material de suport",
            },
        },
        widget: {
            logs: "Registres",
        },
        settings: {
            countries: {
                title: "Bloqueig de Països",
                votingDescription: "Trieu a continuació els països dels quals voleu bloquejar les votacions.",
                enrollmentDescription: "Trieu a continuació els països dels quals voleu bloquejar la preinscripció.",
                error: {
                    errorSaving: "Error en desar la llista de països",
                },
            },
            backupRestore: {
                title: "Còpia de seguretat / Restaurar la configuració del llogater",
                backup: {
                    label: "còpia de seguretat",
                    subtitle: "Còpia de seguretat de les configuracions del llogater",
                },
                restore: {
                    label: "Restaurar",
                    subtitle: "Restaura la configuració del llogater",
                    title: "Importa les configuracions del llogater",
                    paragraph: "Importa configuracions de llogater, configuracions de Keycloak, rols i dades de permisos utilitzant una carpeta comprimida.",
                    tenantConfigOption: "Importa les configuracions del llogater",
                    keycloakConfigOption: "Importa les configuracions de Keycloak",
                    RolesConfigOption: "Importa les configuracions de rols i permisos",
                },
            },
            previewScreen: {
                label: "Prèvies",
                noContent: "No s'han trobat prèvies",
                table: {
                    title: "Vistes prèvies externes",
                    description: "Un registre de les vistes prèvies d'estils de papereta generades mitjançant peticions externes",
                    requestedBy: "Sol·licitat per",
                    document: "Document",
                    url: "URL",
                },
            },
            languages: {
                default: "Llengua per defecte",
            },
        },
        approvalsScreen: {
            column: {
                status: "Estat",
                id: "ID",
                applicantId: "ID del Sol·licitant",
                verificationType: "Tipus de Verificació",
                createdAt: "Creat El",
                updatedAt: "Actualitzat El",
                verified_by: "Verificat Per",
            },
            approvalRequest: "Sol·licitud d'Aprovació",
            title: "Votants",
            subtitle: "Cercar votants coincidents",
            approve: {
                body: "Estàs segur que vols aprovar aquest votant? Aquesta acció no es pot desfer.",
            },
            reject: {
                label: "Rebutja la sol·licitud",
                confirm: "Esteu segur que voleu rebutjar aquest votant? Aquesta acció no es pot revertir.",
                message: "Escriviu aquí el motiu del rebuig",
                rejectReason: "Motiu del rebuig",
                messageRequired: "Es requereix un missatge de rebuig per a l'opció 'Altres'",
                reasons: {
                    "undefined": "-",
                    "insufficient-information": "Données Manquantes",
                    "no-matching-voter": "Votant Non Trouvé",
                    "voter-already-approved": "Déjà Approuvé",
                    "other": "Autre",
                },
            },
            notifications: {
                approveError: "Error en aprovar el votant",
                approveSuccess: "Votant aprovat",
                rejectError: "Error en rebutjar el votant",
                rejectSuccess: "Votant rebutjat",
                VoterApprovedAlready: "El votant ja està aprovat.",
            },
            export: {
                success: "L'exportació d'aplicacions s'ha completat amb èxit",
                error: "Error en exportar les aplicacions",
            },
        },
        monitoringDashboardScreen: {
            voters: {
                title: "Votants",
                enrolledOverseasVoters: "Votants Inscrits a l'Estranger",
                approvalStatus: "Estat d'Aprovació: Votants Aprovats/Desaprovarats",
                manuallyApproval: "Votants Aprovats/Desaprovarats Manualment",
                automaticallyApproval: "Votants Aprovats/Desaprovarats Automàticament",
                authenticatedVoters: "Votants Autenticats",
                invalidUserErrors: "Errors d'Usuari Invàlid:",
                invalidPasswordErrors: "Errors de Contrasenya Invàlida:",
            },
            polls: {
                title: "Enquestes",
                initializedSystems: "Publicacions amb Sistemes Inicialitzats",
                votingOpened: "Publicacions amb Votació Oberta",
                votingClosed: "Publicacions amb Votació Tancada",
                votingStarted: "Publicacions amb Votació Iniciada",
                voterTurnout: "Participació dels Votants",
            },
            tally: {
                title: "Compte",
                activeVotesCounting: "Publicacions amb Comptatge de Vots Actiu",
                generatedERs: "Publicacions amb ERs Generats",
                transmittedResults: "Publicacions amb Resultats Transmesos",
            },
            testing: {
                title: "Proves",
                testElectionVoterCount: "Comptatge de Votants a l'Elecció de Prova",
            },
        },
        certificateAuthorities: {
            title: "Certificats",
            subtitle: "Autoritats de certificació (CA) de confiança per a aquest esdeveniment electoral. Les CA importades s'utilitzen per validar els certificats dels votants.",
            importButton: "Importar certificats",
            type: {
                root: "Arrel",
                intermediate: "Intermedi",
            },
            expiry: {
                expired: "Caducat",
                expiringSoon: "Pròxim a caducar",
                valid: "Vàlid",
            },
            columns: {
                commonName: "Nom comú",
                type: "Tipus",
                issuerCn: "CN de l'emissor",
                notBefore: "Vàlid des de",
                notAfter: "Caduca",
                fingerprint: "Empremta SHA256",
            },
            importDialog: {
                title: "Importar autoritats de certificació",
                subtitle: "Importar un o més certificats CA des d'un fitxer PEM",
                description: "Seleccioneu un fitxer PEM que contingui un o més certificats. S'admeten paquets — cada certificat s'importa individualment.",
                selectFile: "Seleccionar fitxer PEM",
                fileLoaded: "Fitxer carregat ({{bytes}} bytes)",
                importButton: "Importar",
            },
            notify: {
                importSuccess: "S'han importat {{inserted}} certificat(s).",
                importSkipped: "{{count}} omès(os) (ja presents).",
                importErrors: "Problemes en la importació: {{errors}}",
                importError: "Error en la importació: {{error}}",
                deleteSuccess: "Certificat eliminat.",
                deleteError: "Error en eliminar el certificat.",
                exportSuccess: "Certificat(s) exportat(s) correctament.",
                exportError: "Error en exportar els certificats.",
            },
            exportDialog: {
                title: "Exportar autoritats de certificació",
                description: "Esteu a punt d'exportar {{amount}} certificat(s).",
                all: "tots",
            },
            deleteDialog: {
                description: "Esteu segur que voleu suprimir {{count}} certificat(s)?",
            },
            emptyHeader: "No s'han importat autoritats de certificació per a aquest esdeveniment electoral.",
            fileReadError: "Error en llegir el fitxer.",
            viewDialog: {
                title: "Detalls de l'autoritat de certificació",
                subject: "Assumpte",
                issuer: "Emissor",
                serialNumber: "Número de sèrie",
                pemContent: "Contingut PEM",
            },
            confirmDelete: "Eliminar autoritat de certificació",
            confirmDeleteDescription: 'Esteu segurs que voleu eliminar el certificat "{{name}}" (empremta: {{fingerprint}})?',
        },
    },
};
export default catalanTranslation;
